<template>
  <div v-if="isDisp">
    <!-- 水位観測所 -->
    <div
      v-for="(value, key) in dispStgGeoJson"
      v-bind:key="key + 'stg' + mapNum"
    >
      <l-geo-json :geojson="value" :options="options" @click="clickTmIcon" />
      <l-geo-json
        :geojson="value"
        :options="optionsBadge"
        @click="clickTmIcon"
      />
    </div>
    <!-- ダム観測所 -->
    <div
      v-for="(value, key) in dispDamGeoJson"
      v-bind:key="key + 'dam' + mapNum"
    >
      <l-geo-json :geojson="value" :options="options" @click="clickTmIcon" />
      <l-geo-json
        :geojson="value"
        :options="optionsBadge"
        @click="clickTmIcon"
      />
    </div>
    <!-- カメラ観測所 -->
    <div
      v-for="(value, key) in dispScamGeoJson"
      v-bind:key="key + 'scam' + mapNum"
    >
      <l-geo-json :geojson="value" :options="options" @click="clickTmIcon" />
      <l-geo-json
        :geojson="value"
        :options="optionsBadge"
        @click="clickTmIcon"
      />
    </div>
    <!-- 雨量観測所 -->
    <div v-for="(value, key) in dispRnGeoJson" v-bind:key="key + 'rn' + mapNum">
      <l-geo-json :geojson="value" :options="options" @click="clickTmIcon" />
      <l-geo-json
        :geojson="value"
        :options="optionsBadge"
        @click="clickTmIcon"
      />
    </div>
    <!-- 水質観測所 -->
    <div
      v-for="(value, key) in dispQwtrGeoJson"
      v-bind:key="key + 'qwtr' + mapNum"
    >
      <l-geo-json :geojson="value" :options="options" @click="clickTmIcon" />
      <l-geo-json
        :geojson="value"
        :options="optionsBadge"
        @click="clickTmIcon"
      />
    </div>
    <!-- 海岸観測所 -->
    <div
      v-for="(value, key) in dispCoastGeoJson"
      v-bind:key="key + 'coast' + mapNum"
    >
      <l-geo-json :geojson="value" :options="options" @click="clickTmIcon" />
      <l-geo-json
        :geojson="value"
        :options="optionsBadge"
        @click="clickTmIcon"
      />
    </div>
    <!-- 積雪観測所 -->
    <div
      v-for="(value, key) in dispSnwGeoJson"
      v-bind:key="key + 'snw' + mapNum"
    >
      <l-geo-json :geojson="value" :options="options" @click="clickTmIcon" />
      <l-geo-json
        :geojson="value"
        :options="optionsBadge"
        @click="clickTmIcon"
      />
    </div>
    <!-- 危機管理型水位観測所 -->
    <div
      v-for="(value, key) in dispSwstgGeoJson"
      v-bind:key="key + 'swstg' + mapNum"
    >
      <l-geo-json :geojson="value" :options="options" @click="clickTmIcon" />
      <l-geo-json
        :geojson="value"
        :options="optionsBadge"
        @click="clickTmIcon"
      />
    </div>
    <!-- 予警報の基準観測所 -->
    <div v-if="showBaseobs">
      <l-geo-json
        :geojson="baseobsGeoJsons"
        :options="optionsBaseobs"
        @click="clickTmIcon"
      />
      <l-geo-json
        :geojson="baseobsGeoJsons"
        :options="optionsBadgeBaseobs"
        @click="clickTmIcon"
      />
    </div>
    <!-- 選択中観測所のパルス表示 -->
    <l-geo-json v-if="content == 'TmObs' && selectTm" :geojson="selectTm" :options="optionsSelect" />
    <l-geo-json v-else-if="content == 'Riverwarn' && selectedWarnReq.type == 30" :geojson="baseobsGeoJsons" :options="optionsSelectRw" />
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import { LGeoJson } from "vue2-leaflet";
import { pulse } from "@ansur/leaflet-pulse-icon";
import L from "leaflet";
import WebStorage from "../../../lib/webStorage.js";
import Marker from "../../../lib/markerSetting.js";
import Util from "../../../lib/util.js";
import MapUtil from "../../../lib/mapUtil.js";
import mixin from "../../../lib/mixin.js";
import Color from "../../../scss/color.scss";

/**
 * 川の防災情報 地図画面 観測所レイヤー
 * TelemeterLayer.vue
 * @author LIS
 */
export default {
  name: "telemeter-layer",
  mixins: [mixin],
  components: {
    LGeoJson,
    // 宣言しないと動作しないが、未使用のワーニングが出るためeslintの対象外に
    // eslint-disable-next-line
    pulse,
  },
  data() {
    return {
      // ズームレベル後GeoJSON取得要求待機用タイマーID
      requestWaitTimerId: null,
      // 表示フラグ
      isDisp: true,
    };
  },
  /** プロパティ部 */
  props: {
    mapNum: {
      type: Number,
      default: 0,
    },
  },
  /** 初期化部 */
  mounted() {
    // 表示範囲のテレメータGeoJsonを取得
    this.getTelemeterGeoJson();
    // 表示範囲の基準観測所GeoJsonを取得
    this.getBaseobsGeoJson();
    // ブラウザバック時にリロードイベントを登録
    window.addEventListener("popstate", this.reload, false);
  },
  /** 破棄部 */
  destroyed() {
    // リロードイベントを削除
    window.removeEventListener("popstate", this.reload, false);
  },
  /** 算出部 */
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** グラフ設定情報 */
    graphConfig: {
      get() {
        return this.$store.state.Telemeter.graphConfig;
      },
    },
    // 登録地点1情報
    location1Info: {
      get() {
        return this.$store.state.map.point.get(1);
      },
    },
    // 登録地点2情報
    location2Info: {
      get() {
        return this.$store.state.map.point.get(2);
      },
    },
    // 登録地点3情報
    location3Info: {
      get() {
        return this.$store.state.map.point.get(3);
      },
    },
    /** 予警報の基準観測所GeoJson */
    baseobsGeoJsons: {
      get() {
        return this.$store.state.Telemeter.baseobsGeoJsons;
      },
    },
    /**
     * 選択中河川予警報マスタ
     */
    selectedRwDetailMt: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.mt;
      },
    },
    /** 選択中河川予警報リクエストキー */
    selectedWarnReq: {
      get() {
        return this.$store.state.RiverWarn.selectedWarnReq;
      },
    },
    /** 基準観測所アイコン表示設定 */
    showBaseobs: {
      get() {
        // 予警報詳細画面を開いているときのみ表示する
        if (this.$store.state.app.content == "Riverwarn") {
          if (this.baseobsGeoJsons) {
            return true;
          }
        }
        return false;
      },
    },
    // テレメータアイコン描画
    options: {
      get() {
        // 以下が更新された場合に再描画を行う
        //  webストレージ情報
        //  表示グループ設定
        //  ズームレベル
        //  表示コンテンツ
        //  登録地点表示設定
        if (
          this.$store.state.map.editWebStorageDate &&
          this.$store.state.map.viewGroup >= 0 &&
          this.$store.state.map.zoom &&
          this.$store.state.app.content != null &&
          (this.$store.state.map.viewPoint || !this.$store.state.map.viewPoint)
        ) {
          return this.createOption();
        }
        return null;
      },
    },
    // 基準観測所アイコン描画
    optionsBaseobs: {
      get() {
        // 以下が更新された場合に再描画を行う
        //  表示コンテンツ
        //  水位観測所の座標情報
        //  ダム観測所の座標情報
        if (
          this.$store.state.map.zoom &&
          (this.dispStgGeoJson || !this.dispStgGeoJson) &&
          (this.dispDamGeoJson || !this.dispDamGeoJson)
        ) {
          return this.createOptionBaseobs();
        }
        return null;
      },
    },
    // バッジ描画
    optionsBadge: {
      get() {
        // 以下が更新された場合に再描画を行う
        //  webストレージ情報
        //  表示グループ設定
        //  ズームレベル
        //  表示コンテンツ
        //  登録地点表示設定
        if (
          this.$store.state.map.editWebStorageDate &&
          this.$store.state.map.viewGroup >= 0 &&
          this.$store.state.map.zoom &&
          this.$store.state.app.content != null &&
          (this.$store.state.map.viewPoint || !this.$store.state.map.viewPoint)
        ) {
          return this.createBadgeOption();
        }
        return null;
      },
    },
    // 基準観測所用バッジ描画
    optionsBadgeBaseobs: {
      get() {
        // 以下が更新された場合に再描画を行う
        //  ズームレベル
        //  登録地点表示設定
        //  水位観測所の座標情報
        //  ダム観測所の座標情報
        if (
          this.$store.state.map.zoom &&
          (this.$store.state.map.viewPoint ||
            !this.$store.state.map.viewPoint) &&
          (this.dispStgGeoJson || !this.dispStgGeoJson) &&
          (this.dispDamGeoJson || !this.dispDamGeoJson)
        ) {
          return this.createBadgeBaseobsOption();
        }
        return null;
      },
    },
    // 選択中観測所のパルス表示
    optionsSelect: {
      get() {
        return {
          pointToLayer: (feature, latlng) => {
            const iconConf = this.mapConfig.markerSetting.tmPulse;
            const pulseIcon = L.icon.pulse({
              iconSize: iconConf.size,
              iconAnchor: iconConf.anchor,
              color: Color.mapPulse,
              fillColor: "transparent",
              heartbeat: this.mapConfig.pulseSecond,
            });
            return L.marker(latlng, {
              icon: pulseIcon,
              properties: feature.properties,
              latlng,
              zIndexOffset: 0,
              keyboard: false,
            });
          },
          filter: (feature) => {
            return this.tmFilter(feature);
          },
        };
      },
    },
    // 選択中予警報のダム放流通知のパルス表示
    optionsSelectRw: {
      get() {
        return {
          pointToLayer: (feature, latlng) => {
            const iconConf = this.mapConfig.markerSetting.tmPulse;
            const pulseIcon = L.icon.pulse({
              iconSize: iconConf.size,
              iconAnchor: iconConf.anchor,
              color: Color.mapPulse,
              fillColor: "transparent",
              heartbeat: this.mapConfig.pulseSecond,
            });
            return L.marker(latlng, {
              icon: pulseIcon,
              properties: feature.properties,
              latlng,
              zIndexOffset: 0,
              keyboard: false,
            });
          },
          filter: (feature) => {
            return this.baseobsFilterRw(feature);
          },
        };
      },
    },
    /** 水位観測所の座標を取得 */
    dispStgGeoJson: {
      get() {
        // webストレージから個別設定を取得
        const customInfo = WebStorage.getCustomInfo();
        // 個別設定モード
        const customMode = this.isCustomMode();
        // 表示開始ズームレベル
        let dispStartZmLvl = this.setDispStartZmLvlStg(customMode, customInfo);
        if (
          this.$store.state.Telemeter.stgGeoJsons &&
          this.$store.state.app.appTime &&
          this.showKnd.stg
        ) {
          // テレメータGeoJsonの中から該当日時のデータを抽出
          const dateIndex = this.$store.state.Telemeter.stgGeoJsons.findIndex(
            (info) => info.date == this.baseTime
          );
          if (dateIndex >= 0) {
            const stgGeoJson =
              this.$store.state.Telemeter.stgGeoJsons[dateIndex];
            // 超過観測所表示のズームレベルの場合は、市町村単位のGeoJSONは周辺観測所のみ抽出する。
            if (this.$store.state.map.zoom < dispStartZmLvl) {
              let returnJson = [];
              // 超過GeoJSONは全て抽出
              if (stgGeoJson.tmOverGeoJsonInfo) {
                returnJson.push(stgGeoJson.tmOverGeoJsonInfo);
              }

              const aroundPoint = this.aroundPointInfo.tmInfo;
              stgGeoJson.tmGeoJsonInfo.forEach((featureCollection) => {
                // 周辺観測所の市町村以外はスキップ
                if (
                  aroundPoint.twnList.some(
                    (obj) => obj.id == featureCollection.twnCd
                  )
                ) {
                  let geoJsonContainer = JSON.parse(
                    JSON.stringify(featureCollection)
                  );
                  let featureContainer = [];
                  featureCollection.features.forEach((feature) => {
                    // 周辺観測所かつ、基準値超過GeoJSONにない観測所のみ抽出。
                    if (
                      aroundPoint.tmList.includes(feature.properties.obs_fcd)
                    ) {
                      if (stgGeoJson.tmOverGeoJsonInfo) {
                        if (
                          !stgGeoJson.tmOverGeoJsonInfo.features.some(
                            (checkObj) =>
                              checkObj.properties.obs_fcd ==
                              feature.properties.obs_fcd
                          )
                        ) {
                          featureContainer.push(feature);
                        }
                      } else {
                        featureContainer.push(feature);
                      }
                    }
                  });
                  if (featureContainer.length > 0) {
                    geoJsonContainer.features = featureContainer;
                    returnJson.push(geoJsonContainer);
                  }
                }
              });
              return returnJson;
            } else {
              return stgGeoJson.tmGeoJsonInfo;
            }
          }
        }
        return [];
      },
    },
    /** ダム観測所の座標を取得 */
    dispDamGeoJson: {
      get() {
        // webストレージから個別設定を取得
        const customInfo = WebStorage.getCustomInfo();
        // 個別設定モード
        const customMode = this.isCustomMode();
        // 表示開始ズームレベル
        let dispStartZmLvl = customMode
          ? customInfo.damZmLvl
          : this.mapConfig.zoomTmDam;

        if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
          dispStartZmLvl = this.customModeSettingZmLvl(7);
        }
        if (
          this.$store.state.Telemeter.damGeoJsons &&
          this.$store.state.app.appTime &&
          this.showKnd.dam
        ) {
          // テレメータGeoJsonの中から該当日時のデータを抽出
          const dateIndex = this.$store.state.Telemeter.damGeoJsons.findIndex(
            (info) => info.date == this.baseTime
          );
          if (dateIndex >= 0) {
            const damGeoJson =
              this.$store.state.Telemeter.damGeoJsons[dateIndex];
            let returnJson = [];
            // 超過GeoJSONデータは予警報としても扱うため、全ズームレベルで使用する
            if (damGeoJson.tmOverGeoJsonInfo) {
              returnJson.push(damGeoJson.tmOverGeoJsonInfo);
            }

            const aroundPoint = this.aroundPointInfo.tmInfo;
            damGeoJson.tmGeoJsonInfo.forEach((featureCollection) => {
              // 平常ズームレベル未満の場合は、市町村単位のGeoJSONは周辺観測所のみ抽出する。
              if (this.$store.state.map.zoom < dispStartZmLvl) {
                // 周辺観測所の市町村以外はスキップ
                if (
                  aroundPoint.twnList.some(
                    (obj) => obj.id == featureCollection.twnCd
                  )
                ) {
                  let geoJsonContainer = JSON.parse(
                    JSON.stringify(featureCollection)
                  );
                  let featureContainer = [];
                  featureCollection.features.forEach((feature) => {
                    // 周辺観測所かつ、基準値超過GeoJSONにない観測所のみ抽出
                    if (
                      aroundPoint.tmList.includes(feature.properties.obs_fcd)
                    ) {
                      if (damGeoJson.tmOverGeoJsonInfo) {
                        if (
                          !damGeoJson.tmOverGeoJsonInfo.features.some(
                            (checkObj) =>
                              checkObj.properties.obs_fcd ==
                              feature.properties.obs_fcd
                          )
                        ) {
                          featureContainer.push(feature);
                        }
                      } else {
                        featureContainer.push(feature);
                      }
                    }
                  });
                  if (featureContainer.length > 0) {
                    geoJsonContainer.features = featureContainer;
                    returnJson.push(geoJsonContainer);
                  }
                }
              } else {
                // 平常ズームレベル以上の場合は、基準値超過GeoJSONにない観測所のみ抽出
                let geoJsonContainer = JSON.parse(
                  JSON.stringify(featureCollection)
                );
                let featureContainer = [];
                featureCollection.features.forEach((feature) => {
                  if (damGeoJson.tmOverGeoJsonInfo) {
                    if (
                      !damGeoJson.tmOverGeoJsonInfo.features.some(
                        (checkObj) =>
                          checkObj.properties.obs_fcd ==
                          feature.properties.obs_fcd
                      )
                    ) {
                      featureContainer.push(feature);
                    }
                  } else {
                    featureContainer.push(feature);
                  }
                });
                if (featureContainer.length > 0) {
                  geoJsonContainer.features = featureContainer;
                  returnJson.push(geoJsonContainer);
                }
              }
            });
            return returnJson;
            // } else {
            //   return damGeoJson.tmGeoJsonInfo;
            // }
          }
        }
        return [];
      },
    },
    /** カメラの座標を取得 */
    dispScamGeoJson: {
      get() {
        if (this.$store.state.Telemeter.scamGeoJsons) {
          if (this.showKnd.cctv || this.showKnd.scam) {
            return this.$store.state.Telemeter.scamGeoJsons;
          }
        }
        return [];
      },
    },
    /** 雨量観測所の座標を取得 */
    dispRnGeoJson: {
      get() {
        if (
          this.$store.state.Telemeter.rnGeoJsons &&
          this.$store.state.app.appTime &&
          this.showKnd.rn
        ) {
          // テレメータGeoJsonの中から該当日時のデータを抽出
          const dateIndex = this.$store.state.Telemeter.rnGeoJsons.findIndex(
            (info) => info.date == this.baseTime
          );
          if (dateIndex >= 0) {
            return this.$store.state.Telemeter.rnGeoJsons[dateIndex]
              .tmGeoJsonInfo;
          }
        }
        return [];
      },
    },
    /** 水質観測所の座標を取得 */
    dispQwtrGeoJson: {
      get() {
        if (
          this.$store.state.Telemeter.qwtrGeoJsons &&
          this.$store.state.app.appTime &&
          this.showKnd.qwtr
        ) {
          // テレメータGeoJsonの中から該当日時のデータを抽出
          const dateIndex = this.$store.state.Telemeter.qwtrGeoJsons.findIndex(
            (info) => info.date == this.baseTime
          );
          if (dateIndex >= 0) {
            return this.$store.state.Telemeter.qwtrGeoJsons[dateIndex]
              .tmGeoJsonInfo;
          }
        }
        return [];
      },
    },
    /** 海岸観測所の座標を取得 */
    dispCoastGeoJson: {
      get() {
        if (
          this.$store.state.Telemeter.coastGeoJsons &&
          this.$store.state.app.appTime &&
          this.showKnd.coast
        ) {
          // テレメータGeoJsonの中から該当日時のデータを抽出
          const dateIndex = this.$store.state.Telemeter.coastGeoJsons.findIndex(
            (info) => info.date == this.baseTime
          );
          if (dateIndex >= 0) {
            return this.$store.state.Telemeter.coastGeoJsons[dateIndex]
              .tmGeoJsonInfo;
          }
        }
        return [];
      },
    },
    /** 積雪観測所の座標を取得 */
    dispSnwGeoJson: {
      get() {
        if (
          this.$store.state.Telemeter.snwGeoJsons &&
          this.$store.state.app.appTime &&
          this.showKnd.snw
        ) {
          // テレメータGeoJsonの中から該当日時のデータを抽出
          const dateIndex = this.$store.state.Telemeter.snwGeoJsons.findIndex(
            (info) => info.date == this.baseTime
          );
          if (dateIndex >= 0) {
            return this.$store.state.Telemeter.snwGeoJsons[dateIndex]
              .tmGeoJsonInfo;
          }
        }
        return [];
      },
    },
    /** 危機管理型水位観測所の座標を取得 */
    dispSwstgGeoJson: {
      get() {
        // webストレージから個別設定を取得
        const customInfo = WebStorage.getCustomInfo();
        // 個別設定モード
        const customMode = this.isCustomMode();
        // 表示開始ズームレベル
        let dispStartZmLvl = customMode
          ? customInfo.swinZmLvl
          : this.mapConfig.zoomTmSwstg;

        if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
          dispStartZmLvl = this.customModeSettingZmLvl(300);
        }
        if (
          this.$store.state.Telemeter.swstgGeoJsons &&
          this.$store.state.app.appTime &&
          this.showKnd.swstg
        ) {
          // テレメータGeoJsonの中から該当日時のデータを抽出
          const dateIndex = this.$store.state.Telemeter.swstgGeoJsons.findIndex(
            (info) => info.date == this.baseTime
          );
          if (dateIndex >= 0) {
            const swstgGeoJson =
              this.$store.state.Telemeter.swstgGeoJsons[dateIndex];
            // 超過観測所表示のズームレベルの場合は、市町村単位のGeoJSONは周辺観測所のみ抽出する。
            if (this.$store.state.map.zoom < dispStartZmLvl) {
              let returnJson = [];
              // 超過GeoJSONは全て抽出
              if (swstgGeoJson.tmOverGeoJsonInfo) {
                returnJson.push(swstgGeoJson.tmOverGeoJsonInfo);
              }

              const aroundPoint = this.aroundPointInfo.swstgInfo;
              swstgGeoJson.tmGeoJsonInfo.forEach((featureCollection) => {
                // 周辺観測所の市町村以外はスキップ
                if (
                  aroundPoint.twnList.some(
                    (obj) => obj.id == featureCollection.twnCd
                  )
                ) {
                  let geoJsonContainer = JSON.parse(
                    JSON.stringify(featureCollection)
                  );
                  let featureContainer = [];
                  featureCollection.features.forEach((feature) => {
                    // 周辺観測所かつ、基準値超過GeoJSONにない観測所のみ抽出。
                    if (
                      aroundPoint.swstgList.some(
                        (swobsCd) => swobsCd == feature.properties.swobs_cd
                      )
                    ) {
                      if (swstgGeoJson.tmOverGeoJsonInfo) {
                        if (
                          !swstgGeoJson.tmOverGeoJsonInfo.features.some(
                            (checkObj) =>
                              checkObj.properties.swobs_cd ==
                              feature.properties.swobs_cd
                          )
                        ) {
                          featureContainer.push(feature);
                        }
                      } else {
                        featureContainer.push(feature);
                      }
                    }
                  });
                  if (featureContainer.length > 0) {
                    geoJsonContainer.features = featureContainer;
                    returnJson.push(geoJsonContainer);
                  }
                }
              });
              return returnJson;
            } else {
              return swstgGeoJson.tmGeoJsonInfo;
            }
          }
        }
        return [];
      },
    },
    /** 表示市町村取得時刻 */
    townsUpdate: {
      get() {
        return this.$store.state.map.townsAcqTime;
      },
    },
    /** ズームレベル */
    zoom: {
      get() {
        return this.$store.state.map.zoom;
      },
    },
    /** 地図の表示時間間隔 */
    radarInterval: {
      get() {
        return this.$store.state.radar.radarInterval;
      },
    },
    /** 基準時間を計算 */
    baseTime: {
      get() {
        let returnTime;
        if (this.$store.state.radar.radarNumber !== 4) {
          // 1枚表示の場合は、appストアの観測日時を基準にする、
          returnTime = this.$store.state.app.appTime;
        } else {
          // 4枚表示の場合は、レーダ観測日時を基準にする
          let radarTime;
          if (this.$store.state.radar.radarType == "xrain") {
            radarTime = this.$store.state.radar.radarXrainDate;
          } else {
            radarTime = this.$store.state.radar.radarCbandDate;
          }
          returnTime = MapUtil.calcBaseTime(
            radarTime,
            this.mapNum,
            this.$store.state.radar.radarInterval
          );
        }
        // 5分or10分間隔に切り捨て、文字列変換
        let roundTime = Util.roundMinutes(
          returnTime,
          this.$store.state.app.config.appConfig.keepDaysJsonFiles,
          this.$store.state.app.appTimeRound
        );
        return Util.formatDate(roundTime, "YYYY-MM-DD HH:mm");
      },
    },
    /** レーダ履歴動画再生状態 */
    radarHistoryPlayStatus: {
      get() {
        return this.$store.state.radar.historyPlayStatus;
      },
    },
    /** GeoJSON取得状態更新時刻 */
    geoJsonGetStatusTime: {
      get() {
        return this.$store.state.Telemeter.geoJsonGetStatusTime;
      },
    },
    /** 表示対象観測所種別 */
    showKnd: {
      get() {
        let showKnd = {
          stg: false,
          dam: false,
          cctv: false,
          scam: false,
          rn: false,
          qwtr: false,
          coast: false,
          snw: false,
          swstg: false,
        };
        if (
          this.$store.state.map.viewGroup >= 0 &&
          this.$store.state.map.editWebStorageDate &&
          this.$store.state.app.content != "VcCustom"
        ) {
          switch (this.$store.state.map.viewGroup) {
            case 0:
              showKnd.stg = true;
              showKnd.swstg = true;
              showKnd.dam = true;
              showKnd.cctv = true;
              showKnd.scam = true;
              break;
            case 1:
              showKnd.rn = true;
              break;
            case 2:
              showKnd.qwtr = true;
              showKnd.coast = true;
              showKnd.snw = true;
              break;
            case 3:
              break;
            case 4:
              showKnd = JSON.parse(JSON.stringify(this.aroundPointInfo.knd));
              break;
            case 5:
              showKnd.stg = WebStorage.getCustomInfo().stage;
              showKnd.dam = WebStorage.getCustomInfo().dam;
              showKnd.rn = WebStorage.getCustomInfo().rain;
              showKnd.cctv = WebStorage.getCustomInfo().cctv;
              showKnd.scam = WebStorage.getCustomInfo().scam;
              showKnd.qwtr = WebStorage.getCustomInfo().wtrQual;
              showKnd.coast = WebStorage.getCustomInfo().coast;
              showKnd.snw = WebStorage.getCustomInfo().snow;
              showKnd.swstg = WebStorage.getCustomInfo().swin;
              break;
          }

          // 個別観測所画面表示中は、強制的にその種別を表示する
          if (
            this.$store.state.app.content == "TmObs" &&
            this.$route.query["itmkndCd"]
          ) {
            const itmkndCd = this.$route.query["itmkndCd"];
            if (itmkndCd == 4) {
              showKnd.stg = true;
            } else if (itmkndCd == 7) {
              showKnd.dam = true;
            } else if (itmkndCd == 100) {
              showKnd.cctv = true;
            } else if (itmkndCd == 200) {
              showKnd.scam = true;
            } else if (
              itmkndCd == 1 ||
              itmkndCd == 2 ||
              itmkndCd == 20 ||
              itmkndCd == 21
            ) {
              showKnd.rn = true;
            } else if (itmkndCd == 6) {
              showKnd.qwtr = true;
            } else if (itmkndCd == 12) {
              showKnd.coast = true;
            } else if (itmkndCd == 3) {
              showKnd.snw = true;
            } else if (itmkndCd == 300) {
              showKnd.swstg = true;
            }
          }
        } else if (this.$store.state.app.content == "VcCustom") {
          // 個別設定画面の場合はwebStrage設定を優先する
          showKnd.stg = WebStorage.getCustomInfo().stage;
          showKnd.dam = WebStorage.getCustomInfo().dam;
          showKnd.rn = WebStorage.getCustomInfo().rain;
          showKnd.cctv = WebStorage.getCustomInfo().cctv;
          showKnd.scam = WebStorage.getCustomInfo().scam;
          showKnd.qwtr = WebStorage.getCustomInfo().wtrQual;
          showKnd.coast = WebStorage.getCustomInfo().coast;
          showKnd.snw = WebStorage.getCustomInfo().snow;
          showKnd.swstg = WebStorage.getCustomInfo().swin;
        }

        // ダム観測所は、予警報表示の場合も表示する
        if (this.judgeShowRw()) {
          showKnd.dam = true;
        }
        // 簡易版起動の場合、水質・海岸・積雪深は表示しない
        if (global.KWB_MODE == "reduction") {
          showKnd.qwtr = false;
          showKnd.coast = false;
          showKnd.snw = false;
        }
        return showKnd;
      },
    },
    /** 登録地点の周辺観測所情報 */
    aroundPointInfo: {
      get() {
        return this.$store.state.map.aroundPointInfo;
      },
    },
    /** 市町村座標リスト */
    townLatLngList: {
      get() {
        return this.$store.state.map.townLatLngList;
      },
    },
    /** 選択中テレメータ情報パラメータ */
    selectParam: {
      get() {
        // パネルが個別観測所（TmObs）かつ、queryパラメーターにitmkndCdが存在する
        if (
          this.$store.state.Telemeter.selectedTmParam &&
          this.$store.state.app.content === "TmObs" &&
          this.$route.query["itmkndCd"]
        ) {
          // 危機管理
          if (this.$route.query["itmkndCd"] == 300) {
            return this.$store.state.Swin.selectedSwParam;
          }
          // それ以外
          return this.$store.state.Telemeter.selectedTmParam;

        // パネルが予警報（Riverwarn）かつ、ダム観測所
        } else if (
          this.$store.state.Telemeter.selectedTmParam &&
          this.$store.state.app.content === "Riverwarn" &&
          this.$store.state.Telemeter.selectedTmParam.itmkndCd == 7
        ) {
          return this.$store.state.Telemeter.selectedTmParam;
        }
        return null;
      },
    },
    /** 選択中テレメータGeoJSON情報 */
    selectTm: {
      get() {
        if (this.selectParam) {
          if (this.selectParam.itmkndCd == 4) {
            // 水位
            return this.searchSelectGeoJson(
              this.dispStgGeoJson,
              this.selectParam
            );
          } else if (this.selectParam.itmkndCd == 7) {
            // ダム
            return this.searchSelectGeoJson(
              this.dispDamGeoJson,
              this.selectParam
            );
          } else if (
            this.selectParam.itmkndCd == 100 ||
            this.selectParam.itmkndCd == 200
          ) {
            // カメラ
            return this.searchSelectGeoJson(
              this.dispScamGeoJson,
              this.selectParam
            );
          } else if (
            this.selectParam.itmkndCd == 1 ||
            this.selectParam.itmkndCd == 2 ||
            this.selectParam.itmkndCd == 20 ||
            this.selectParam.itmkndCd == 21
          ) {
            // 雨量
            return this.searchSelectGeoJson(
              this.dispRnGeoJson,
              this.selectParam
            );
          } else if (this.selectParam.itmkndCd == 6) {
            // 水質
            return this.searchSelectGeoJson(
              this.dispQwtrGeoJson,
              this.selectParam
            );
          } else if (this.selectParam.itmkndCd == 12) {
            // 海岸
            return this.searchSelectGeoJson(
              this.dispCoastGeoJson,
              this.selectParam
            );
          } else if (this.selectParam.itmkndCd == 3) {
            // 積雪
            return this.searchSelectGeoJson(
              this.dispSnwGeoJson,
              this.selectParam
            );
          } else if (this.selectParam.itmkndCd == 300) {
            // 危機管理型水位
            return this.searchSelectGeoJson(
              this.dispSwstgGeoJson,
              this.selectParam
            );
          }
        }
        return null;
      },
    },
    /** 最新値ファイル用欠測判定時間によって算出した、欠測判定観測日時 */
    missingDateTime: {
      get() {
        // 画面表示日時(4枚表示を考慮)
        let appTime = MapUtil.calcBaseTime(
          this.$store.state.app.appTime,
          this.mapNum,
          this.$store.state.radar.radarInterval
        );
        // 画面表示日時から最新値ファイル用欠測判定時間を差し引く
        return Util.formatDate(
          Util.subMinutes(appTime, this.$store.state.Telemeter.missingTime)
        );
      },
    },
    /** 水防団モード */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /** 表示コンテンツ */
    content: {
      get() {
        return this.$store.state.app.content
      }
    }
  },
  methods: {
    /**
     * 表示範囲のテレメータGeoJsonを取得
     */
    getTelemeterGeoJson() {
      const customInfo = WebStorage.getCustomInfo();
      const customMode = this.isCustomMode();
      // 地図番号が0(1枚表示か4枚表示の1枚目)のときのみ処理を行う
      if (this.mapNum == 0) {
        // 取得時間リスト
        let getTimeList = [];
        if (
          this.$store.state.radar.radarNumber === 4 ||
          this.$store.getters["radar/isReadyMap"]
        ) {
          // 4枚表示または動画再生
          // レーダの履歴動画再生時間リストを5分or10分間隔に切り捨てる
          getTimeList = MapUtil.getRoundTimeList(
            this.$store.state.radar.historyPlayList,
            this.$store.state.app.config.appConfig.keepDaysJsonFiles,
            this.$store.state.app.appTimeRound
          );
        } else {
          // 1枚表示
          getTimeList = [this.baseTime];
        }

        // 水位GeoJSONの取得
        if (this.showKnd.stg) {
          let towns = [];
          let prefs = [];
          let prefFlg = false;
          let getOverFlg = false;
          let dispStartZmLvl = this.setDispStartZmLvlStg(
            customMode,
            customInfo
          );
          // 対象市町村判定
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            // 平常レベル以上なら地図表示範囲が対象
            if (
              this.$store.state.map.zoom < this.mapConfig.zoomReferenceTmTowns
            ) {
              // 都道府県単位
              prefFlg = true;
              prefs = this.$store.state.map.prefs;
            } else {
              // 市町村単位
              towns = this.$store.state.map.towns;
            }
          } else if (
            this.$store.state.map.zoom >= this.mapConfig.zoomTmAround
          ) {
            // 平常レベル未満、周辺観測所レベル以上は周辺観測所の所属市町村のみ
            towns = this.aroundPointInfo.tmInfo.twnList;
          }
          // 超過判定
          if (
            this.$store.state.map.zoom >= this.mapConfig.zoomTmStgOv &&
            this.$store.state.map.zoom < dispStartZmLvl
          ) {
            // 超過レベル以上、平常レベル未満の場合のみ取得する
            getOverFlg = true;
          }
          this.$store.dispatch("Telemeter/getStgGeoJsons", {
            towns: towns,
            getTimeList: getTimeList,
            getOverFlg: getOverFlg,
            townLatLngList: this.townLatLngList,
            prefFlg: prefFlg,
            prefs: prefs,
          });
        }
        // ダムGeoJSONの取得
        if (this.showKnd.dam) {
          // 予警報の表示有無
          let isRw = this.judgeShowRw();

          let isTmDam = false;
          // ダム観測所の表示有無
          if (
            this.$store.state.app.content == "TmObs" &&
            this.$route.query["itmkndCd"] == 7
          ) {
            // ダム個別観測所画面表示中は、強制的にダム観測所を表示する
            isTmDam = true;
          } else if (this.$store.state.app.content == "VcCustom") {
            // 個別設定画面表示中は、webストレージ設定に従う
            isTmDam = WebStorage.getCustomInfo().dam;
          } else {
            // その他画面表示中は、表示観測所設定を参照
            if (this.$store.state.map.viewGroup == 0) {
              isTmDam = true;
            } else if (this.$store.state.map.viewGroup == 4) {
              // 表示観測所が登録観測所の場合は、登録地点に登録されている観測所のみを表示する
              isTmDam = this.aroundPointInfo.knd.dam;
            } else if (this.isCustomMode()) {
              // 表示観測所が個別設定の場合は、webストレージ設定に従う
              isTmDam = WebStorage.getCustomInfo().dam;
            }
          }

          // GeoJSONの取得
          let towns = [];
          let prefs = [];
          let prefFlg = false;
          let getOverFlg = false;
          let dispStartZmLvl = customMode
            ? customInfo.damZmLvl
            : this.mapConfig.zoomTmDam;

          if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
            dispStartZmLvl = this.customModeSettingZmLvl(7);
          }
          if (isRw && !isTmDam) {
            // 予警報のみ表示する場合、超過GeoJSONのみ取得する
            if (this.$store.state.map.zoom >= this.mapConfig.zoomTmDamOv) {
              getOverFlg = true;
            }
          } else {
            if (this.$store.state.map.zoom < dispStartZmLvl) {
              // 平常表示ズームレベル未満
              if (!isRw && isTmDam) {
                // ダム観測所のみ表示の場合、登録地点の市町村GeoJSONのみ取得する
                if (this.$store.state.map.zoom >= this.mapConfig.zoomTmAround) {
                  towns = this.aroundPointInfo.tmInfo.twnList;
                }
              } else {
                // 予警報とダム観測所どちらも表示する場合は、
                // 超過GeoJSONと登録地点の市町村GeoJSONを取得する
                if (this.$store.state.map.zoom >= this.mapConfig.zoomTmDamOv) {
                  getOverFlg = true;
                }
                if (this.$store.state.map.zoom >= this.mapConfig.zoomTmAround) {
                  towns = this.aroundPointInfo.tmInfo.twnList;
                }
              }
            } else {
              // 平常レベル以上なら地図表示範囲が対象
              if (
                this.$store.state.map.zoom < this.mapConfig.zoomReferenceTmTowns
              ) {
                // 都道府県単位
                prefFlg = true;
                prefs = this.$store.state.map.prefs;
              } else {
                // 市町村単位
                towns = this.$store.state.map.towns;
              }
            }
          }
          this.$store.dispatch("Telemeter/getDamGeoJsons", {
            towns: towns,
            getTimeList: getTimeList,
            getOverFlg: getOverFlg,
            townLatLngList: this.townLatLngList,
            prefFlg: prefFlg,
            prefs: prefs,
          });
        }
        // カメラGeoJSONの取得
        if (this.showKnd.scam || this.showKnd.cctv) {
          // 対象市町村判定
          let towns = [];
          let prefs = [];
          let prefFlg = false;
          let dispStartZmLvlScam = customMode
            ? customInfo.scamZmLvl
            : this.mapConfig.zoomTmScam;
          let dispStartZmLvlCctv = customMode
            ? customInfo.cctvZmLvl
            : this.mapConfig.zoomTmCctv;

          if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
            dispStartZmLvlScam = this.customModeSettingZmLvl(200);
          }
          if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
            dispStartZmLvlCctv = this.customModeSettingZmLvl(100);
          }
          if (
            this.$store.state.map.zoom >= dispStartZmLvlScam ||
            this.$store.state.map.zoom >= dispStartZmLvlCctv
          ) {
            // 平常レベル以上なら表示市町村が対象
            if (
              this.$store.state.map.zoom < this.mapConfig.zoomReferenceTmTowns
            ) {
              // 都道府県単位
              prefFlg = true;
              prefs = this.$store.state.map.prefs;
            } else {
              // 市町村単位
              towns = this.$store.state.map.towns;
            }
          } else if (
            this.$store.state.map.zoom >= this.mapConfig.zoomTmAround
          ) {
            // 平常レベル未満、周辺観測所レベル以上は周辺観測所の所属市町村のみ
            towns = this.aroundPointInfo.scamInfo.twnList;
          }
          this.$store.dispatch("Telemeter/getScamGeoJsons", {
            towns: towns,
            townLatLngList: this.townLatLngList,
            prefFlg: prefFlg,
            prefs: prefs,
          });
        }
        // 雨量GeoJSONの取得
        if (this.showKnd.rn) {
          // 対象市町村判定
          let towns = [];
          let prefs = [];
          let prefFlg = false;
          let dispStartZmLvl = customMode
            ? customInfo.rainZmLvl
            : this.mapConfig.zoomTmRn;

          if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
            dispStartZmLvl = this.customModeSettingZmLvl(1 || 2 || 20 || 21);
          }
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            // 平常レベル以上なら地図表示範囲が対象
            if (
              this.$store.state.map.zoom < this.mapConfig.zoomReferenceTmTowns
            ) {
              // 都道府県単位
              prefFlg = true;
              prefs = this.$store.state.map.prefs;
            } else {
              // 市町村単位
              towns = this.$store.state.map.towns;
            }
          } else if (
            this.$store.state.map.zoom >= this.mapConfig.zoomTmAround
          ) {
            // 平常レベル未満、周辺観測所レベル以上は周辺観測所の所属市町村のみ
            towns = this.aroundPointInfo.tmInfo.twnList;
          }
          this.$store.dispatch("Telemeter/getRnGeoJsons", {
            towns: towns,
            getTimeList: getTimeList,
            townLatLngList: this.townLatLngList,
            prefFlg: prefFlg,
            prefs: prefs,
          });
        }
        // 水質GeoJSONの取得
        if (this.showKnd.qwtr) {
          // 対象市町村判定
          let towns = [];
          let prefs = [];
          let prefFlg = false;
          let dispStartZmLvl = customMode
            ? customInfo.wtrQualZmLvl
            : this.mapConfig.zoomTmQwtr;
     
          if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
            dispStartZmLvl = this.customModeSettingZmLvl(6);
          }
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            // 平常レベル以上なら地図表示範囲が対象
            if (
              this.$store.state.map.zoom < this.mapConfig.zoomReferenceTmTowns
            ) {
              // 都道府県単位
              prefFlg = true;
              prefs = this.$store.state.map.prefs;
            } else {
              // 市町村単位
              towns = this.$store.state.map.towns;
            }
          } else if (
            this.$store.state.map.zoom >= this.mapConfig.zoomTmAround
          ) {
            // 平常レベル未満、周辺観測所レベル以上は周辺観測所の所属市町村のみ
            towns = this.aroundPointInfo.tmInfo.twnList;
          }
          this.$store.dispatch("Telemeter/getQwtrGeoJsons", {
            towns: towns,
            getTimeList: getTimeList,
            townLatLngList: this.townLatLngList,
            prefFlg: prefFlg,
            prefs: prefs,
          });
        }
        // 海岸GeoJSONの取得
        if (this.showKnd.coast) {
          // 対象市町村判定
          let towns = [];
          let prefs = [];
          let prefFlg = false;
          let dispStartZmLvl = customMode
            ? customInfo.coastZmLvl
            : this.mapConfig.zoomTmCoast;

          if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
            dispStartZmLvl = this.customModeSettingZmLvl(12);
          }
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            // 平常レベル以上なら地図表示範囲が対象
            if (
              this.$store.state.map.zoom < this.mapConfig.zoomReferenceTmTowns
            ) {
              // 都道府県単位
              prefFlg = true;
              prefs = this.$store.state.map.prefs;
            } else {
              // 市町村単位
              towns = this.$store.state.map.towns;
            }
          } else if (
            this.$store.state.map.zoom >= this.mapConfig.zoomTmAround
          ) {
            // 平常レベル未満、周辺観測所レベル以上は周辺観測所の所属市町村のみ
            towns = this.aroundPointInfo.tmInfo.twnList;
          }
          this.$store.dispatch("Telemeter/getCoastGeoJsons", {
            towns: towns,
            getTimeList: getTimeList,
            townLatLngList: this.townLatLngList,
            prefFlg: prefFlg,
            prefs: prefs,
          });
        }
        // 積雪GeoJSONの取得
        if (this.showKnd.snw) {
          // 対象市町村判定
          let towns = [];
          let prefs = [];
          let prefFlg = false;
          let dispStartZmLvl = customMode
            ? customInfo.snowZmLvl
            : this.mapConfig.zoomTmSnw;

          if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
            dispStartZmLvl = this.customModeSettingZmLvl(3);
          }
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            // 平常レベル以上なら地図表示範囲が対象
            if (
              this.$store.state.map.zoom < this.mapConfig.zoomReferenceTmTowns
            ) {
              // 都道府県単位
              prefFlg = true;
              prefs = this.$store.state.map.prefs;
            } else {
              // 市町村単位
              towns = this.$store.state.map.towns;
            }
          } else if (
            this.$store.state.map.zoom >= this.mapConfig.zoomTmAround
          ) {
            // 平常レベル未満、周辺観測所レベル以上は周辺観測所の所属市町村のみ
            towns = this.aroundPointInfo.tmInfo.twnList;
          }
          this.$store.dispatch("Telemeter/getSnwGeoJsons", {
            towns: towns,
            getTimeList: getTimeList,
            townLatLngList: this.townLatLngList,
            prefFlg: prefFlg,
            prefs: prefs,
          });
        }
        // 危機管理型水位GeoJSONの取得
        if (this.showKnd.swstg) {
          let towns = [];
          let prefs = [];
          let prefFlg = false;
          let getOverFlg = false;
          let dispStartZmLvl = customMode
            ? customInfo.swinZmLvl
            : this.mapConfig.zoomTmSwstg;

          if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
            dispStartZmLvl = this.customModeSettingZmLvl(300);
          }
          // 対象市町村判定
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            // 平常レベル以上なら地図表示範囲が対象
            if (
              this.$store.state.map.zoom < this.mapConfig.zoomReferenceTmTowns
            ) {
              // 都道府県単位
              prefFlg = true;
              prefs = this.$store.state.map.prefs;
            } else {
              // 市町村単位
              towns = this.$store.state.map.towns;
            }
          } else if (
            this.$store.state.map.zoom >= this.mapConfig.zoomTmAround
          ) {
            // 平常レベル未満、周辺観測所レベル以上は周辺観測所の所属市町村のみ
            towns = this.aroundPointInfo.swstgInfo.twnList;
          }
          // 超過判定
          if (
            this.$store.state.map.zoom >= this.mapConfig.zoomTmSwstgOv &&
            this.$store.state.map.zoom < dispStartZmLvl
          ) {
            // 超過レベル以上、平常レベル未満の場合のみ取得する
            getOverFlg = true;
          }
          this.$store.dispatch("Telemeter/getSwstgGeoJsons", {
            towns: towns,
            getTimeList: getTimeList,
            getOverFlg: getOverFlg,
            townLatLngList: this.townLatLngList,
            prefFlg: prefFlg,
            prefs: prefs,
          });
        }
      }
    },
    /**
     * 表示範囲の基準観測所GeoJsonを取得
     */
    getBaseobsGeoJson() {
      // 選択中河川予警報リクエストキーの有無を判定
      if (this.selectedWarnReq.type && this.selectedWarnReq.cd) {
        // 基準観測所GeoJSONの取得
        this.$store.dispatch("Telemeter/getBaseobsGeoJsons", {
          baseTime: this.baseTime,
          rwType: this.selectedWarnReq.type,
          rwCd: this.selectedWarnReq.cd,
        });
      }
    },
    /** アイコンクリック時処理 */
    clickTmIcon(e) {
      // 地点登録操作時は、地図移動を行わない。
      if (
        this.$store.state.map.editLocationMode === 0 &&
        this.$store.state.map.editTmMode === 0
      ) {
        // 周辺に表示が重なる観測所が表示されているかチェック
        if (this.checkOverlapTm(e.latlng)) {
          // 観測所一覧ダイアログを表示して処理を抜ける
          if (this.$store.state.app.mode == "mb") {
            // 地図上のダイアログを全て非表示
            this.$store.commit("map/dialogAllClose");
            // モバイルモード初期表示(全てのダイアログを非表示)
            this.routerPush("/mb");
            this.$store.commit("app/setContent", "");
          }
          this.$store.commit("map/setShowTmList", true);
          return;
        }

        // 画面遷移
        if (
          e.sourceTarget.feature.properties.itmknd_cd === 100 ||
          e.sourceTarget.feature.properties.itmknd_cd === 200
        ) {
          this.$store.commit("Telemeter/setSelectedTmParamScam", {
            itmkndCd: e.sourceTarget.feature.properties.itmknd_cd,
            scamId: e.sourceTarget.feature.properties.id,
            ownCd: e.sourceTarget.feature.properties.own_cd,
            sysCamId: e.sourceTarget.feature.properties.sys_cam_id,
          });
          // 地図アイコンからの遷移フラグを設定
          this.$store.commit("Telemeter/setMapIconFlg", true);
          if (this.$store.state.app.mode == "pc") {
            this.routerPushTmScam("/pc/tm");
          } else {
            this.routerPushTmScam("/mb/tm");
          }
        } else if (e.sourceTarget.feature.properties.itmknd_cd === 300) {
          // 危機管理型水位
          this.$store.commit("Swin/setSelectedSwParam", {
            swofcCd: e.sourceTarget.feature.properties.swofc_cd,
            itmkndCd: e.sourceTarget.feature.properties.itmknd_cd,
            swobsCd: e.sourceTarget.feature.properties.swobs_cd,
          });
          // 地図アイコンからの遷移フラグを設定
          this.$store.commit("Telemeter/setMapIconFlg", true);
          if (this.$store.state.app.mode == "pc") {
            this.routerPushTmSw("/pc/tm");
          } else {
            this.routerPushTmSw("/mb/tm");
          }
        } else {
          // 観測所
          const obsFcd = e.sourceTarget.feature.properties.obs_fcd;
          this.$store.commit("Telemeter/setSelectedTmParam", {
            ofcCd: Number(obsFcd.substr(0, 5)),
            itmkndCd: e.sourceTarget.feature.properties.itmknd_cd,
            obsCd: Number(obsFcd.substr(8, 5)),
          });
          // 地図アイコンからの遷移フラグを設定
          this.$store.commit("Telemeter/setMapIconFlg", true);
          if (this.$store.state.app.mode == "pc") {
            this.routerPushTm("/pc/tm");
          } else {
            this.routerPushTm("/mb/tm");
          }
        }
      }
      // 周辺観測所編集モードの場合は、周辺観測所選択の更新を行う
      else if (this.$store.state.map.editTmMode === 1) {
        // カメラ
        if (
          e.sourceTarget.feature.properties.itmknd_cd === 100 ||
          e.sourceTarget.feature.properties.itmknd_cd === 200
        ) {
          this.$store.commit("map/setEditTm", {
            itmkndCd: e.sourceTarget.feature.properties.itmknd_cd,
            scamId: e.sourceTarget.feature.properties.id,
            ownCd: e.sourceTarget.feature.properties.own_cd,
            sysCamId: e.sourceTarget.feature.properties.sys_cam_id,
            sysId: e.sourceTarget.feature.properties.sys_id,
            lat: e.latlng.lat,
            lon: e.latlng.lng,
          });
        }
        // 危機管理型水位
        else if (e.sourceTarget.feature.properties.itmknd_cd === 300) {
          this.$store.commit("map/setEditTm", {
            itmkndCd: e.sourceTarget.feature.properties.itmknd_cd,
            swobsCd: e.sourceTarget.feature.properties.swobs_cd,
            lat: e.latlng.lat,
            lon: e.latlng.lng,
          });
        }
        // その他観測所
        else {
          this.$store.commit("map/setEditTm", {
            itmkndCd: e.sourceTarget.feature.properties.itmknd_cd,
            obsFcd: e.sourceTarget.feature.properties.obs_fcd,
            lat: e.latlng.lat,
            lon: e.latlng.lng,
          });
        }
      }
    },
    /** 観測所オプション生成 */
    createOption() {
      return {
        pointToLayer: (feature, latlng) => {
          return this.tmPointToLayer(feature, latlng);
        },
        filter: (feature) => {
          return this.tmFilter(feature);
        },
      };
    },
    /** 基準観測所オプション生成 */
    createOptionBaseobs() {
      return {
        pointToLayer: (feature, latlng) => {
          return this.tmPointToLayer(feature, latlng);
        },
        filter: (feature) => {
          return this.baseobsFilter(feature);
        },
      };
    },
    /** テレメータアイコン描画判定 */
    tmPointToLayer(feature, latlng) {
      const itmkndCd = feature.properties.itmknd_cd;
      // アイコンの種類とoffset設定を振り分け
      let size = null;
      let ic = null;
      let offset = 0;
      let name = "";
      let kana = "";

      // offset設定値
      const OFFSET_CCTV = 50;
      const OFFSET_SCAM = 50;
      const OFFSET_MISSING = 100;
      const OFFSET_NORMAL = 150;
      const OFFSET_FLDCTL = 200;
      const OFFSET_CAUTION = 250;
      const OFFSET_REFUGE = 300;
      const OFFSET_DANGER = 350;
      const OFFSET_FLOOD = 400;
      const OFFSET_SELECT = 450;

      if (itmkndCd === 4) {
        // 水位
        name = feature.properties.obs_nm;
        kana = feature.properties.obs_kana;
        size = this.mapConfig.markerSetting.tmStr.size;
        // 基準値超過GeoJSONには内容コードが設定されないため、項目そのものが無い場合は欠測としない
        if (
          (typeof feature.properties.stg_ccd !== "undefined" &&
            (feature.properties.stg_ccd == null ||
              feature.properties.stg_ccd >= 128)) ||
          this.checkMissing(feature.properties.obs_time)
        ) {
          // 欠測
          ic = Marker.getIconObj("stgMissing", size);
          offset = OFFSET_MISSING;
        } else if (feature.properties.stg_ovlvl === 90) {
          // 氾濫発生（変化なし）
          ic = Marker.getIconObj("stgFlood", size);
          offset = OFFSET_FLOOD;
          // 基準値超過GeoJSONには最新値水位変化量内容コードの項目そのものが存在しないため、正常とみなす
          if (
            typeof feature.properties.stg_ltst_chg_ccd === "undefined" ||
            feature.properties.stg_ltst_chg_ccd <= 128
          ) {
            if (feature.properties.stg_ltst_chg > 0) {
              // 氾濫発生（変化量上昇）
              ic = Marker.getIconObj("stgFloodUp", size);
            } else if (feature.properties.stg_ltst_chg < 0) {
              // 氾濫発生（変化量下降）
              ic = Marker.getIconObj("stgFloodDown", size);
            }
          }
        } else if (
          feature.properties.rsrv_stg === null &&
          feature.properties.warn_stg === null &&
          feature.properties.spcl_warn_stg === null &&
          feature.properties.dng_stg === null
        ) {
          // 基準水位未設定
          ic = Marker.getIconObj("stgNotset", size);
          offset = OFFSET_MISSING;
        } else if (feature.properties.stg_ovlvl === 80) {
          // 氾濫危険水位超過（変化なし）
          ic = Marker.getIconObj("stgDanger", size);
          offset = OFFSET_DANGER;
          if (
            typeof feature.properties.stg_ltst_chg_ccd === "undefined" ||
            feature.properties.stg_ltst_chg_ccd <= 128
          ) {
            if (feature.properties.stg_ltst_chg > 0) {
              // 氾濫危険水位超過（変化量上昇）
              ic = Marker.getIconObj("stgDangerUp", size);
            } else if (feature.properties.stg_ltst_chg < 0) {
              // 氾濫危険水位超過（変化量下降）
              ic = Marker.getIconObj("stgDangerDown", size);
            }
          }
        } else if (feature.properties.stg_ovlvl === 60) {
          // 避難判断水位超過（変化なし）
          ic = Marker.getIconObj("stgRefuge", size);
          offset = OFFSET_REFUGE;
          if (
            typeof feature.properties.stg_ltst_chg_ccd === "undefined" ||
            feature.properties.stg_ltst_chg_ccd <= 128
          ) {
            if (feature.properties.stg_ltst_chg > 0) {
              // 避難判断水位超過（変化量上昇）
              ic = Marker.getIconObj("stgRefugeUp", size);
            } else if (feature.properties.stg_ltst_chg < 0) {
              // 避難判断水位超過（変化量下降）
              ic = Marker.getIconObj("stgRefugeDown", size);
            }
          }
        } else if (feature.properties.stg_ovlvl === 30) {
          // 氾濫注意水位超過（変化なし）
          ic = Marker.getIconObj("stgCaution", size);
          offset = OFFSET_CAUTION;
          if (
            typeof feature.properties.stg_ltst_chg_ccd === "undefined" ||
            feature.properties.stg_ltst_chg_ccd <= 128
          ) {
            if (feature.properties.stg_ltst_chg > 0) {
              // 氾濫注意水位超過（変化量上昇）
              ic = Marker.getIconObj("stgCautionUp", size);
            } else if (feature.properties.stg_ltst_chg < 0) {
              // 氾濫注意水位超過（変化量下降）
              ic = Marker.getIconObj("stgCautionDown", size);
            }
          }
        } else if (feature.properties.stg_ovlvl === 10 && this.isFldCtl) {
          // 水防団待機水位超過（変化なし）
          ic = Marker.getIconObj("stgFldctl", size);
          offset = OFFSET_FLDCTL;
          if (
            typeof feature.properties.stg_ltst_chg_ccd === "undefined" ||
            feature.properties.stg_ltst_chg_ccd <= 128
          ) {
            if (feature.properties.stg_ltst_chg > 0) {
              // 水防団待機水位超過（変化量上昇）
              ic = Marker.getIconObj("stgFldctlUp", size);
            } else if (feature.properties.stg_ltst_chg < 0) {
              // 水防団待機水位超過（変化量下降）
              ic = Marker.getIconObj("stgFldctlDown", size);
            }
          }
        } else {
          // 平常
          ic = Marker.getIconObj("stgNomal", size);
          offset = OFFSET_NORMAL;
        }
      } else if (
        itmkndCd === 1 ||
        itmkndCd === 2 ||
        itmkndCd === 20 ||
        itmkndCd === 21
      ) {
        // 雨量
        name = feature.properties.obs_nm;
        kana = feature.properties.obs_kana;
        size = this.mapConfig.markerSetting.tmRn.size;
        if (
          (typeof feature.properties.rn_10m_ccd !== "undefined" &&
            (feature.properties.rn_10m_ccd == null ||
              feature.properties.rn_10m_ccd >= 128) &&
            typeof feature.properties.rn_inc_ccd !== "undefined" &&
            (feature.properties.rn_inc_ccd == null ||
              feature.properties.rn_inc_ccd >= 128) &&
            typeof feature.properties.rn_60m_ccd !== "undefined" &&
            (feature.properties.rn_60m_ccd == null ||
              feature.properties.rn_60m_ccd >= 128) &&
            typeof feature.properties.rn_hr10m_ccd !== "undefined" &&
            (feature.properties.rn_hr10m_ccd == null ||
              feature.properties.rn_hr10m_ccd >= 128)) ||
          this.checkMissing(feature.properties.obs_time)
        ) {
          // 欠測
          ic = Marker.getIconObj("rnMissing", size);
          offset = OFFSET_MISSING;
        } else {
          // 平常
          ic = Marker.getIconObj("rnNormal", size);
          offset = OFFSET_NORMAL;
        }
      } else if (itmkndCd === 6) {
        // 水質
        name = feature.properties.obs_nm;
        kana = feature.properties.obs_kana;
        size = this.mapConfig.markerSetting.tmQwtr.size;
        if (
          (typeof feature.properties.wtrtmp_ccd !== "undefined" &&
            (feature.properties.wtrtmp_ccd == null ||
              feature.properties.wtrtmp_ccd >= 128) &&
            typeof feature.properties.conduct_ccd !== "undefined" &&
            (feature.properties.conduct_ccd == null ||
              feature.properties.conduct_ccd >= 128) &&
            typeof feature.properties.dox_ccd !== "undefined" &&
            (feature.properties.dox_ccd == null ||
              feature.properties.dox_ccd >= 128) &&
            typeof feature.properties.ph_ccd !== "undefined" &&
            (feature.properties.ph_ccd == null ||
              feature.properties.ph_ccd >= 128) &&
            typeof feature.properties.turbdty_ccd !== "undefined" &&
            (feature.properties.turbdty_ccd == null ||
              feature.properties.turbdty_ccd >= 128) &&
            typeof feature.properties.cod_ccd !== "undefined" &&
            (feature.properties.cod_ccd == null ||
              feature.properties.cod_ccd >= 128) &&
            typeof feature.properties.amn_ccd !== "undefined" &&
            (feature.properties.amn_ccd == null ||
              feature.properties.amn_ccd >= 128) &&
            typeof feature.properties.slt_ccd !== "undefined" &&
            (feature.properties.slt_ccd == null ||
              feature.properties.slt_ccd >= 128)) ||
          this.checkMissing(feature.properties.obs_time)
        ) {
          // 欠測
          ic = Marker.getIconObj("qwtrMissing", size);
          offset = OFFSET_MISSING;
        } else if (
          feature.properties.tycls_cd === 0 ||
          feature.properties.tysct1_cd === 0
        ) {
          // 類型指定なし
          ic = Marker.getIconObj("qwtrNotset", size);
          offset = OFFSET_MISSING;
        } else if (
          (feature.properties.wtrtmp_ovcd &&
            feature.properties.wtrtmp_ovcd !== 0) ||
          (feature.properties.conduct_ovcd &&
            feature.properties.conduct_ovcd !== 0) ||
          (feature.properties.dox_ovcd && feature.properties.dox_ovcd !== 0) ||
          (feature.properties.ph_ovcd && feature.properties.ph_ovcd !== 0) ||
          (feature.properties.turbdty_ovcd &&
            feature.properties.turbdty_ovcd !== 0) ||
          (feature.properties.cod_ovcd && feature.properties.cod_ovcd !== 0) ||
          (feature.properties.amn_ovcd && feature.properties.amn_ovcd !== 0) ||
          (feature.properties.slt_ovcd && feature.properties.slt_ovcd !== 0)
        ) {
          // 基準値超過
          ic = Marker.getIconObj("qwtrExcess", size);
          offset = OFFSET_DANGER;
        } else {
          // 平常
          ic = Marker.getIconObj("qwtrNormal", size);
          offset = OFFSET_NORMAL;
        }
      } else if (itmkndCd === 7) {
        // ダム
        name = feature.properties.obs_nm;
        kana = feature.properties.obs_kana;
        size = this.mapConfig.markerSetting.tmDam.size;
        if (feature.properties.damdsch_lvl === 70) {
          // 異常洪水時防災操作等実施中
          ic = Marker.getIconObj("damAbnormal", size);
          offset = OFFSET_DANGER;
        } else if (feature.properties.damdsch_lvl === 50) {
          // 洪水貯留操作実施中
          ic = Marker.getIconObj("damStorage", size);
          offset = OFFSET_CAUTION;
        } else if (
          (typeof feature.properties.stor_lvl_ccd !== "undefined" &&
            (feature.properties.stor_lvl_ccd == null ||
              feature.properties.stor_lvl_ccd >= 128) &&
            typeof feature.properties.stor_cap_ccd !== "undefined" &&
            (feature.properties.stor_cap_ccd == null ||
              feature.properties.stor_cap_ccd >= 128) &&
            typeof feature.properties.stor_pcnt_irr_ccd !== "undefined" &&
            (feature.properties.stor_pcnt_irr_ccd == null ||
              feature.properties.stor_pcnt_irr_ccd >= 128) &&
            typeof feature.properties.all_sink_ccd !== "undefined" &&
            (feature.properties.all_sink_ccd == null ||
              feature.properties.all_sink_ccd >= 128) &&
            typeof feature.properties.all_disch_ccd !== "undefined" &&
            (feature.properties.all_disch_ccd == null ||
              feature.properties.all_disch_ccd >= 128) &&
            typeof feature.properties.stor_pcnt_eff_ccd !== "undefined" &&
            (feature.properties.stor_pcnt_eff_ccd == null ||
              feature.properties.stor_pcnt_eff_ccd >= 128)) ||
          this.checkMissing(feature.properties.obs_time)
        ) {
          // 欠測
          ic = Marker.getIconObj("damMissing", size);
          offset = OFFSET_MISSING;
        } else {
          if (feature.properties.rw_notice_mng == 1) {
            // 平常
            ic = Marker.getIconObj("damNormal", size);
            offset = OFFSET_NORMAL;
          } else {
            // 管理外
            ic = Marker.getIconObj("damNotset", size);
            offset = OFFSET_NORMAL;
          }
        }
      } else if (itmkndCd === 12) {
        // 海岸
        name = feature.properties.obs_nm;
        kana = feature.properties.obs_kana;
        size = this.mapConfig.markerSetting.tmCoast.size;
        if (
          (typeof feature.properties.onthwv_hght_ccd !== "undefined" &&
            (feature.properties.onthwv_hght_ccd == null ||
              feature.properties.onthwv_hght_ccd >= 128) &&
            typeof feature.properties.tidlvl_ccd !== "undefined" &&
            (feature.properties.tidlvl_ccd == null ||
              feature.properties.tidlvl_ccd >= 128) &&
            typeof feature.properties.avewnd_spd_ccd !== "undefined" &&
            (feature.properties.avewnd_spd_ccd == null ||
              feature.properties.avewnd_spd_ccd >= 128)) ||
          this.checkMissing(feature.properties.obs_time)
        ) {
          // 欠測
          ic = Marker.getIconObj("coastMissing", size);
          offset = OFFSET_MISSING;
        } else if (
          feature.properties.wv_hght_caut === null &&
          feature.properties.wv_hght_warn === null &&
          feature.properties.tidlvl_caut === null &&
          feature.properties.tidlvl_warn === null &&
          feature.properties.wnd_spd_caut === null &&
          feature.properties.wnd_spd_warn === null
        ) {
          // 基準値未設定
          ic = Marker.getIconObj("coastNotset", size);
          offset = OFFSET_NORMAL;
        } else if (
          (feature.properties.onthwv_hght_warn_ovflg &&
            feature.properties.onthwv_hght_warn_ovflg !== 0) ||
          (feature.properties.tidlvl_warn_ovflg &&
            feature.properties.tidlvl_warn_ovflg !== 0) ||
          (feature.properties.avewnd_spd_warn_ovflg &&
            feature.properties.avewnd_spd_warn_ovflg !== 0)
        ) {
          // 警戒値超過
          ic = Marker.getIconObj("coastWarning", size);
          offset = OFFSET_DANGER;
        } else if (
          (feature.properties.onthwv_hght_caut_ovflg &&
            feature.properties.onthwv_hght_caut_ovflg !== 0) ||
          (feature.properties.tidlvl_caut_ovflg &&
            feature.properties.tidlvl_caut_ovflg !== 0) ||
          (feature.properties.avewnd_spd_caut_ovflg &&
            feature.properties.avewnd_spd_caut_ovflg !== 0)
        ) {
          // 注意値超過
          ic = Marker.getIconObj("coastCaution", size);
          offset = OFFSET_CAUTION;
        } else {
          // 平常
          ic = Marker.getIconObj("coastNormal", size);
          offset = OFFSET_NORMAL;
        }
      } else if (itmkndCd === 3) {
        // 積雪
        name = feature.properties.obs_nm;
        kana = feature.properties.obs_kana;
        size = this.mapConfig.markerSetting.tmSnw.size;
        if (
          (typeof feature.properties.snwdp_ccd !== "undefined" &&
            (feature.properties.snwdp_ccd == null ||
              feature.properties.snwdp_ccd >= 128)) ||
          this.checkMissing(feature.properties.obs_time)
        ) {
          // 欠測
          ic = Marker.getIconObj("snwMissing", size);
          offset = OFFSET_MISSING;
        } else if (
          feature.properties.snwdp * 100 >=
          this.$store.state.app.config.graphConfig.snow.snowGraphLvl6
        ) {
          // 200cm以上
          ic = Marker.getIconObj("snw200", size);
          offset = OFFSET_NORMAL;
        } else if (
          feature.properties.snwdp * 100 >=
          this.$store.state.app.config.graphConfig.snow.snowGraphLvl5
        ) {
          // 150cm～199cm
          ic = Marker.getIconObj("snw150", size);
          offset = OFFSET_NORMAL;
        } else if (
          feature.properties.snwdp * 100 >=
          this.$store.state.app.config.graphConfig.snow.snowGraphLvl4
        ) {
          // 100cm～149cm
          ic = Marker.getIconObj("snw100", size);
          offset = OFFSET_NORMAL;
        } else if (
          feature.properties.snwdp * 100 >=
          this.$store.state.app.config.graphConfig.snow.snowGraphLvl3
        ) {
          // 50cm～99cm
          ic = Marker.getIconObj("snw50", size);
          offset = OFFSET_NORMAL;
        } else if (
          feature.properties.snwdp * 100 >=
          this.$store.state.app.config.graphConfig.snow.snowGraphLvl2
        ) {
          // 20cm～49cm
          ic = Marker.getIconObj("snw20", size);
          offset = OFFSET_NORMAL;
        } else if (
          feature.properties.snwdp * 100 >=
          this.$store.state.app.config.graphConfig.snow.snowGraphLvl1
        ) {
          // 5cm～19cm
          ic = Marker.getIconObj("snw5", size);
          offset = OFFSET_NORMAL;
        } else if (feature.properties.snwdp * 100 > 0) {
          // 0cm～4cm
          ic = Marker.getIconObj("snw0over", size);
          offset = OFFSET_NORMAL;
        } else {
          // 0cm
          ic = Marker.getIconObj("snw0", size);
          offset = OFFSET_NORMAL;
        }
      } else if (itmkndCd === 300) {
        // 危機管理型水位
        name = feature.properties.swobs_nm;
        kana = feature.properties.swobs_kana;
        size = this.mapConfig.markerSetting.tmSwstg.size;
        if (feature.properties.stg === null) {
          // 欠測
          ic = Marker.getIconObj("swstgMissing", size);
          offset = OFFSET_MISSING;
        } else if (feature.properties.swstg_ovlvl === 90) {
          // 氾濫開始水位超過
          ic = Marker.getIconObj("swstgFlood", size);
          offset = OFFSET_FLOOD;
        } else if (feature.properties.swstg_ovlvl === 80) {
          // 危険水位超過
          ic = Marker.getIconObj("swstgDanger", size);
          offset = OFFSET_DANGER;
        } else if (feature.properties.swstg_ovlvl === 30) {
          // 観測開始水位超過
          ic = Marker.getIconObj("swstgStart", size);
          offset = OFFSET_REFUGE;
        } else {
          // 平常
          ic = Marker.getIconObj("swstgNomal", size);
          offset = OFFSET_NORMAL;
        }
      } else if (itmkndCd === 100) {
        // 河川カメラ
        name = feature.properties.name;
        kana = feature.properties.name_kana;
        size = this.mapConfig.markerSetting.tmCctv.size;
        ic = Marker.getIconObj("cctv", size);
        offset = OFFSET_CCTV;
      } else if (itmkndCd === 200) {
        // 簡易カメラ
        name = feature.properties.name;
        kana = feature.properties.name_kana;
        size = this.mapConfig.markerSetting.tmScam.size;
        ic = Marker.getIconObj("scam", size);
        offset = OFFSET_SCAM;
      }

      // 選択中の観測所は最前面に表示する
      if (this.selectParam) {
        if (
          this.selectParam.itmkndCd == 100 ||
          this.selectParam.itmkndCd == 200
        ) {
          // カメラ
          if (feature.properties.id == this.selectParam.scamId) {
            offset = OFFSET_SELECT;
          }
        } else if (this.selectParam.itmkndCd == 300) {
          // 危機管理型水位
          if (feature.properties.swobs_cd == this.selectParam.swobsCd) {
            offset = OFFSET_SELECT;
          }
        } else {
          // 観測所
          if (
            feature.properties.ofc_cd == this.selectParam.ofcCd &&
            feature.properties.obs_cd == this.selectParam.obsCd
          ) {
            offset = OFFSET_SELECT;
          }
        }
      }

      feature.properties.iconPath = ic.options.iconUrl;
      let returnMarker = L.marker(latlng, {
        icon: ic,
        properties: feature.properties,
        latlng,
        zIndexOffset: offset,
        keyboard: false,
      });
      // 指定ズームレベル以上でツールチップ表示
      if (this.$store.state.map.zoom >= this.mapConfig.zoomShowTmTooltip) {
        let tooltipName = "";
        if (kana && name) {
          tooltipName = "<font size='-2'>" + kana + "</font>" + "<br/>" + name;
        } else if (kana) {
          tooltipName = kana;
        } else if (name) {
          tooltipName = name;
        }
        returnMarker.bindTooltip(tooltipName).openTooltip();
      }

      return returnMarker;
    },
    /** 登録地点のバッジ描画オプション生成 */
    createBadgeOption() {
      return {
        pointToLayer: (feature, latlng) => {
          return this.badgePointToLayer(feature, latlng);
        },
        filter: (feature) => {
          return this.tmFilter(feature);
        },
      };
    },
    /** 登録地点のバッジ描画オプション生成（基準観測所用） */
    createBadgeBaseobsOption() {
      return {
        pointToLayer: (feature, latlng) => {
          return this.badgePointToLayer(feature, latlng);
        },
        filter: (feature) => {
          return this.baseobsFilter(feature);
        },
      };
    },
    /** 登録地点のバッジ描画判定 */
    badgePointToLayer(feature, latlng) {
      if (this.checkAroundTm(feature.properties)) {
        return L.marker(latlng, {
          icon: Marker.getIconObj(
            "badge",
            this.mapConfig.markerSetting.badge.size,
            this.mapConfig.markerSetting.badge.anchor
          ),
          properties: feature.properties,
          latlng,
          zIndexOffset: 500,
        });
      }
      return null;
    },
    /** 観測所アイコンの表示制御 */
    tmFilter(feature) {
      const itmkndCd = feature.properties.itmknd_cd;

      // 登録観測所表示
      if (
        this.judgeShowRw() &&
        itmkndCd == 7 &&
        feature.properties.damdsch_lvl > 0
      ) {
        // 予警報表示が必要な場合は、ダム観測所のみ登録地点でなくても表示
      } else if (this.$store.state.map.viewGroup === 4) {
        // 個別観測所画面表示中の種別は登録地点でなくても表示する
        if (
          this.$store.state.app.content != "TmObs" ||
          this.$route.query["itmkndCd"] != itmkndCd
        ) {
          if (this.checkAroundTm(feature.properties)) {
            // ズームレベル
            return this.tmZoomControl(feature.properties);
          } else {
            return false;
          }
        }
      }

      // 水位観測所
      if (itmkndCd === 4) {
        if (this.showKnd.stg) {
          // ズームレベル
          return this.tmZoomControl(feature.properties);
        }
      }
      // 雨量観測所
      else if (
        itmkndCd === 1 ||
        itmkndCd === 2 ||
        itmkndCd === 20 ||
        itmkndCd === 21
      ) {
        if (this.showKnd.rn) {
          // ズームレベル
          return this.tmZoomControl(feature.properties);
        }
      }
      // 水質観測所
      else if (itmkndCd === 6) {
        if (this.showKnd.qwtr) {
          // ズームレベル
          return this.tmZoomControl(feature.properties);
        }
      }
      // ダム諸量観測所
      else if (itmkndCd === 7) {
        if (this.showKnd.dam) {
          // ズームレベル
          return this.tmZoomControl(feature.properties);
        }
      }
      // 海岸観測所
      else if (itmkndCd === 12) {
        if (this.showKnd.coast) {
          // ズームレベル
          return this.tmZoomControl(feature.properties);
        }
      }
      // 積雪深観測所
      else if (itmkndCd === 3) {
        if (this.showKnd.snw) {
          // ズームレベル
          return this.tmZoomControl(feature.properties);
        }
      }
      // 危機管理型水位観測所
      else if (itmkndCd === 300) {
        if (this.showKnd.swstg) {
          // ズームレベル
          return this.tmZoomControl(feature.properties);
        }
      }
      // カメラ
      else if (itmkndCd === 100) {
        if (this.showKnd.cctv) {
          // ズームレベル
          return this.tmZoomControl(feature.properties);
        }
      }
      // 簡易カメラ
      else if (itmkndCd === 200) {
        if (this.showKnd.scam) {
          // ズームレベル
          return this.tmZoomControl(feature.properties);
        }
      }
      return false;
    },
    /** 基準観測所アイコンの表示制御 */
    baseobsFilter(feature) {
      if (
        this.selectedWarnReq.type == 10 ||
        this.selectedWarnReq.type == 11 ||
        this.selectedWarnReq.type == 20
      ) {
        if (this.showKnd.stg) {
          let stgList = this.dispStgGeoJson;

          // 抽出した水位観測所のfeatureの数だけループ
          for (let gCnt = 0; gCnt < stgList.length; gCnt++) {
            for (let fCnt = 0; fCnt < stgList[gCnt].features.length; fCnt++) {
              // 表示されていない水位観測所アイコンは重複判定から除外する
              if (this.tmFilter(stgList[gCnt].features[fCnt])) {
                // 伝送記号の重複判定
                if (
                  stgList[gCnt].features[fCnt].properties.obs_fcd ==
                  feature.properties.obs_fcd
                ) {
                  return false;
                }
              }
            }
          }
        }
      } else if (this.selectedWarnReq.type == 30) {
        if (this.showKnd.dam) {
          let stgList = this.dispDamGeoJson;

          // 抽出したダム観測所のfeatureの数だけループ
          for (let gCnt = 0; gCnt < stgList.length; gCnt++) {
            for (let fCnt = 0; fCnt < stgList[gCnt].features.length; fCnt++) {
              // 表示されていないダム観測所アイコンは重複判定から除外する
              if (this.tmFilter(stgList[gCnt].features[fCnt])) {
                // 伝送記号の重複判定
                if (
                  stgList[gCnt].features[fCnt].properties.obs_fcd ==
                  feature.properties.obs_fcd
                ) {
                  return false;
                }
              }
            }
          }
        }
      }

      // 洪水予報を選択中の場合
      if (this.selectedWarnReq.type == 10) {
        // ズームレベル
        if (this.$store.state.map.zoom >= this.mapConfig.zoomTmBaseFldfrs) {
          return true;
        }
      }
      // 水位周知河川情報を選択中の場合
      else if (this.selectedWarnReq.type == 11) {
        // ズームレベル
        if (this.$store.state.map.zoom >= this.mapConfig.zoomTmBaseEvstgs) {
          return true;
        }
      }
      // 水防警報を選択中の場合
      else if (this.selectedWarnReq.type == 20) {
        // ズームレベル
        if (this.$store.state.map.zoom >= this.mapConfig.zoomTmBaseFldctls) {
          return true;
        }
      }
      // ダム放流通知を選択中の場合
      else if (this.selectedWarnReq.type == 30) {
        // ズームレベル
        if (this.$store.state.map.zoom >= this.mapConfig.zoomTmBaseDamdsch) {
          return true;
        }
      } else {
        return false;
      }
    },
    /** 予警報ダム放流通知パルスの表示制御 */
    baseobsFilterRw(feature) {
      if (
        feature.properties.itmknd_cd == this.selectedRwDetailMt.itmkndCd &&
        feature.properties.obs_cd == this.selectedRwDetailMt.obsCd &&
        feature.properties.ofc_cd == this.selectedRwDetailMt.ofcCd
      ) {
        const itmkndCd = feature.properties.itmknd_cd;
        const customMode = this.isCustomMode();
        const dispStartZmLvl = customMode
          ? this.setDispStartZmLvlTm(itmkndCd, feature.properties)
          : this.mapConfig.zoomTmBaseDamdsch;
          
        if (feature.properties.damdsch_lvl > 0) {
          if (this.$store.state.map.zoom >= this.mapConfig.zoomTmDamOv) {
            return true;
          }
        } else {
          if (this.$store.state.map.zoom >= this.mapConfig.zoomTmBaseDamdsch) {
            return true;
          } else if (this.$store.state.map.zoom >= dispStartZmLvl) {
            return true;
          }
        }
      }
      return false;
    },
    /** 観測所種別毎のズームレベル制御 */
    tmZoomControl(properties) {
      const itmkndCd = properties.itmknd_cd;
      const customMode = this.isCustomMode();
      const dispStartZmLvl = customMode
        ? this.setDispStartZmLvlTm(itmkndCd, properties)
        : this.setDefaultZmLvl(itmkndCd);
      // 周辺観測所
      if (this.checkAroundTm(properties)) {
        if (this.$store.state.map.zoom >= this.mapConfig.zoomTmAround) {
          return true;
        }
      }

      // 水位観測所
      if (itmkndCd === 4) {
        let zoomTmStgOv = this.mapConfig.zoomTmStgOv;
        let zoomTmFldctlOv = this.mapConfig.zoomTmStgOv;
        if (dispStartZmLvl < this.mapConfig.zoomTmStgOv) {
          zoomTmStgOv = dispStartZmLvl;
        }
        if (dispStartZmLvl < this.mapConfig.zoomTmFldctlOv) {
          zoomTmFldctlOv = dispStartZmLvl;
        }
        // 欠測または基準値未設定
        if (
          properties.stg_ccd >= 128 ||
          this.checkMissing(properties.obs_time) ||
          (properties.rsrv_stg === null &&
            properties.warn_stg === null &&
            properties.spcl_warn_stg === null &&
            properties.dng_stg === null)
        ) {
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            return true;
          }
        }
        // 基準値超過
        else if (properties.stg_ovlvl >= 30) {
          if (this.$store.state.map.zoom >= zoomTmStgOv) {
            return true;
          }
        }
        // 水防団待機水位超過
        else if (properties.stg_ovlvl === 10 && this.isFldCtl) {
          if (this.$store.state.map.zoom >= zoomTmFldctlOv) {
            return true;
          }
        } else {
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            return true;
          }
        }
      }
      // 雨量観測所
      else if (
        itmkndCd === 1 ||
        itmkndCd === 2 ||
        itmkndCd === 20 ||
        itmkndCd === 21
      ) {
        if (this.$store.state.map.zoom >= dispStartZmLvl) {
          return true;
        }
      }
      // 水質観測所
      else if (itmkndCd === 6) {
        if (this.$store.state.map.zoom >= dispStartZmLvl) {
          return true;
        }
      }
      // ダム諸量観測所
      else if (itmkndCd === 7) {
        // 欠測
        if (
          (properties.stor_lvl_ccd >= 128 &&
            properties.stor_cap_ccd >= 128 &&
            properties.stor_pcnt_irr_ccd >= 128 &&
            properties.all_sink_ccd >= 128 &&
            properties.all_disch_ccd >= 128 &&
            properties.stor_pcnt_eff_ccd >= 128) ||
          this.checkMissing(properties.obs_time)
        ) {
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            return true;
          }
        }
        // 異常洪水時防災操作等実施中 または 洪水貯留操作実施中 の条件
        else if (properties.damdsch_lvl > 0) {
          if (this.$store.state.map.zoom >= this.mapConfig.zoomTmDamOv) {
            return true;
          }
        } else {
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            return true;
          }
        }
      }
      // 海岸観測所
      else if (itmkndCd === 12) {
        if (this.$store.state.map.zoom >= dispStartZmLvl) {
          return true;
        }
      }
      // 積雪深観測所
      else if (itmkndCd === 3) {
        if (this.$store.state.map.zoom >= dispStartZmLvl) {
          return true;
        }
      }
      // 危機管理型水位観測所
      else if (itmkndCd === 300) {
        let zoomTmSwstgOv = this.mapConfig.zoomTmSwstgOv;
        if (dispStartZmLvl < this.mapConfig.zoomTmSwstgOv) {
          zoomTmSwstgOv = dispStartZmLvl;
        }
        // 欠測
        if (properties.stg === null) {
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            return true;
          }
        }
        // 基準値超過
        else if (
          properties.swstg_ovlvl >=
          this.$store.state.app.config.overViewConfig.swstg.dispOvlvl
        ) {
          if (this.$store.state.map.zoom >= zoomTmSwstgOv) {
            return true;
          }
          // 平常
        } else {
          if (this.$store.state.map.zoom >= dispStartZmLvl) {
            return true;
          }
        }
      }
      // カメラ
      else if (itmkndCd === 100) {
        if (this.$store.state.map.zoom >= dispStartZmLvl) {
          return true;
        }
      }
      // 簡易カメラ
      else if (itmkndCd === 200) {
        if (this.$store.state.map.zoom >= dispStartZmLvl) {
          return true;
        }
      }
      return false;
    },
    /** 登録地点の周辺観測所の判定 */
    checkAroundTm(properties) {
      // 登録地点非表示の場合は周辺観測所として扱わない（地点登録画面表示時は除く）
      if (
        this.$store.state.app.content != "VcPoint" &&
        this.$store.state.map.viewPoint == false
      ) {
        return false;
      }
      if (properties.itmknd_cd == 100 || properties.itmknd_cd == 200) {
        // カメラ
        if (this.aroundPointInfo.scamInfo.scamList.includes(properties.id)) {
          return true;
        }
      } else if (properties.itmknd_cd == 300) {
        // 危機管理型水位
        if (
          this.aroundPointInfo.swstgInfo.swstgList.some(
            (id) => id == properties.swobs_cd
          )
        ) {
          return true;
        }
      } else {
        // その他観測所
        if (this.aroundPointInfo.tmInfo.tmList.includes(properties.obs_fcd)) {
          return true;
        }
      }
      return false;
    },
    /** 周辺に表示が重なる観測所が表示されているかチェック */
    checkOverlapTm(latlng) {
      // 周辺判定の基準値
      // ズームレベルによって決定する
      const jadgeVal = this.mapConfig.overlapTmValue.find((tmVal) => {
        return tmVal.zoom === this.$store.state.map.zoom;
      });
      // 基準値が取得出来た場合に、周辺判定を行う
      if (jadgeVal) {
        let overlapTmList = [];
        // 表示中の全てのGeoJSONを集約
        let allFeatures = [];
        if (this.showKnd.stg) {
          this.dispStgGeoJson.forEach((geoJsonObj) => {
            geoJsonObj.features.forEach((featureObj) => {
              // 非表示の観測所は対象外となるため、フィルター判定を行う
              if (this.tmFilter(featureObj)) {
                allFeatures.push(featureObj);
              }
            });
          });
        }
        if (this.showKnd.dam) {
          this.dispDamGeoJson.forEach((geoJsonObj) => {
            geoJsonObj.features.forEach((featureObj) => {
              if (this.tmFilter(featureObj)) {
                allFeatures.push(featureObj);
              }
            });
          });
        }
        if (this.showKnd.cctv || this.showKnd.scam) {
          this.dispScamGeoJson.forEach((geoJsonObj) => {
            geoJsonObj.features.forEach((featureObj) => {
              if (this.tmFilter(featureObj)) {
                allFeatures.push(featureObj);
              }
            });
          });
        }
        if (this.showKnd.rn) {
          this.dispRnGeoJson.forEach((geoJsonObj) => {
            geoJsonObj.features.forEach((featureObj) => {
              if (this.tmFilter(featureObj)) {
                allFeatures.push(featureObj);
              }
            });
          });
        }
        if (this.showKnd.qwtr) {
          this.dispQwtrGeoJson.forEach((geoJsonObj) => {
            geoJsonObj.features.forEach((featureObj) => {
              if (this.tmFilter(featureObj)) {
                allFeatures.push(featureObj);
              }
            });
          });
        }
        if (this.showKnd.coast) {
          this.dispCoastGeoJson.forEach((geoJsonObj) => {
            geoJsonObj.features.forEach((featureObj) => {
              if (this.tmFilter(featureObj)) {
                allFeatures.push(featureObj);
              }
            });
          });
        }
        if (this.showKnd.snw) {
          this.dispSnwGeoJson.forEach((geoJsonObj) => {
            geoJsonObj.features.forEach((featureObj) => {
              if (this.tmFilter(featureObj)) {
                allFeatures.push(featureObj);
              }
            });
          });
        }
        if (this.showKnd.swstg) {
          this.dispSwstgGeoJson.forEach((geoJsonObj) => {
            geoJsonObj.features.forEach((featureObj) => {
              if (this.tmFilter(featureObj)) {
                allFeatures.push(featureObj);
              }
            });
          });
        }
        // 基準観測所
        if (this.baseobsGeoJsons) {
          this.baseobsGeoJsons.features.forEach((featureObj) => {
            if (this.baseobsFilter(featureObj)) {
              allFeatures.push(featureObj);
            }
          });
        }
        // 表示範囲のGeoJsonの配列と、その中のfeaturesの配列の観測所をチェック
        for (let jsonCnt = 0; jsonCnt < allFeatures.length; jsonCnt++) {
          // 判定対象観測所のfeature情報を格納
          const feature = allFeatures[jsonCnt];

          // 対象座標に対して、判定の基準値の範囲に存在するかチェック
          // 小数点計算の誤差を無くすため10*9倍にして計算する
          if (
            feature.geometry.coordinates[0] * Math.pow(10, 9) <=
              latlng.lng * Math.pow(10, 9) + jadgeVal.value * Math.pow(10, 9) &&
            feature.geometry.coordinates[0] * Math.pow(10, 9) >=
              latlng.lng * Math.pow(10, 9) - jadgeVal.value * Math.pow(10, 9) &&
            feature.geometry.coordinates[1] * Math.pow(10, 9) <=
              latlng.lat * Math.pow(10, 9) + jadgeVal.value * Math.pow(10, 9) &&
            feature.geometry.coordinates[1] * Math.pow(10, 9) >=
              latlng.lat * Math.pow(10, 9) - jadgeVal.value * Math.pow(10, 9)
          ) {
            // 表示の場合は観測所情報を一覧に追加
            if (
              feature.properties.itmknd_cd === 100 ||
              feature.properties.itmknd_cd === 200
            ) {
              // カメラ
              overlapTmList.push({
                itmkndCd: feature.properties.itmknd_cd,
                scamId: feature.properties.id,
                ownCd: feature.properties.own_cd,
                sysCamId: feature.properties.sys_cam_id,
                name: feature.properties.name,
                iconPath: feature.properties.iconPath,
              });
            } else if (feature.properties.itmknd_cd === 300) {
              // 危機管理型水位
              overlapTmList.push({
                itmkndCd: feature.properties.itmknd_cd,
                swobsCd: feature.properties.swobs_cd,
                swofcCd: feature.properties.swofc_cd,
                name: feature.properties.swobs_nm,
                iconPath: feature.properties.iconPath,
              });
            } else {
              // テレメータ
              overlapTmList.push({
                itmkndCd: feature.properties.itmknd_cd,
                obsFcd: feature.properties.obs_fcd,
                name: feature.properties.obs_nm,
                iconPath: feature.properties.iconPath,
              });
            }
          }
        }
        // 判定基準値の範囲内の観測所が2件以上存在する場合、重複有と判断する
        if (overlapTmList.length >= 2) {
          this.$store.commit("map/setOverlapTmList", overlapTmList);
          return true;
        }
      }
      return false;
    },
    /** 選択中観測所のGeoJSONデータを探す */
    searchSelectGeoJson(geoJson, selectParam) {
      let returnGeoJson = null;
      geoJson.forEach((geoJson) => {
        let baseGeoJson = JSON.parse(JSON.stringify(geoJson));
        let selectFeature = [];
        baseGeoJson.features.forEach((featureObj) => {
          if (selectParam.itmkndCd == 100 || selectParam.itmkndCd == 200) {
            // カメラ
            if (featureObj.properties.id == selectParam.scamId) {
              selectFeature.push(featureObj);
            }
          } else if (selectParam.itmkndCd == 300) {
            // 危機管理型水位
            if (featureObj.properties.swobs_cd == selectParam.swobsCd) {
              selectFeature.push(featureObj);
            }
          } else {
            // 観測所
            if (
              featureObj.properties.ofc_cd == selectParam.ofcCd &&
              featureObj.properties.obs_cd == selectParam.obsCd &&
              featureObj.properties.itmknd_cd == selectParam.itmkndCd
            ) {
              selectFeature.push(featureObj);
            }
          }
        });

        if (selectFeature.length > 0) {
          baseGeoJson.features = selectFeature;
          returnGeoJson = baseGeoJson;
        }
      });
      return returnGeoJson;
    },
    /**
     * 予警報の表示有無判定
     */
    judgeShowRw() {
      if (
        this.$store.state.app.content == "RiverwarnList" ||
        this.$store.state.app.content == "Riverwarn"
      ) {
        // 予警報画面表示中は、強制的にダム観測所を表示する
        return true;
      } else if (this.$store.state.app.content == "VcCustom") {
        // 個別設定画面表示中は、webストレージ設定に従う
        return WebStorage.getCustomInfo().damdsch;
      } else {
        // その他画面表示中は、表示設定の河川予警報を参照
        if (this.$store.state.map.viewRiverWarn) {
          if (this.$store.state.map.viewGroup == 5) {
            // 表示観測所が個別設定の場合は、webストレージ設定に従う
            return WebStorage.getCustomInfo().damdsch;
          } else {
            return true;
          }
        }
      }
      return false;
    },
    /**
     * 観測日時チェック
     */
    checkMissing(obsTime) {
      // 欠測判定観測日時より観測日時が過去の場合、欠測として扱う
      if (
        Util.toDate(obsTime).getTime() <=
        Util.toDate(this.missingDateTime).getTime()
      ) {
        return true;
      }
      return false;
    },
    /**
     * Layerを再描画
     */
    reload() {
      this.isDisp = false;
      setTimeout(() => {
        this.isDisp = true;
      }, 10);
    },
    /**
     * 表示開始ズームレベル設定（水位観測）
     */
    setDispStartZmLvlStg(customMode, customInfo) {
      let dispStartZmLvl = this.mapConfig.zoomTmStg;
      // 個別設定モードかつ基準観測所のみ適用の場合、より小さい値を表示開始ズームレベルに設定する
      if (customMode) {
        if (customInfo.baseObsOnly) {
          dispStartZmLvl =
            customInfo.stageZmLvl < this.mapConfig.zoomTmStg
              ? customInfo.stageZmLvl
              : this.mapConfig.zoomTmStg;

        }
        else if(this.$store.state.app.content === "TmObs") {
          dispStartZmLvl = this.customModeSettingZmLvl(4);
        } else {
          dispStartZmLvl = customInfo.stageZmLvl;
        }
      }
      return dispStartZmLvl;
    },
    /**
     * 観測所ごとの表示開始ズームレベル設定
     */
    setDispStartZmLvlTm(itmkndCd, properties) {
      const baseObsOnly = WebStorage.getCustomInfo().baseObsOnly;
      // 基準観測所のみ適用で、基準観測所の場合は個別設定の表示開始ズームレベルを使用する
      if (itmkndCd === 4 && baseObsOnly) {
        return properties.fldfr_flg === 1 ||
          properties.evstg_flg === 1 ||
          properties.fldctl_flg === 1
          ? this.setCustomZmLvl(itmkndCd)
          : this.setDefaultZmLvl(itmkndCd);
      } else if(this.isCustomMode() && this.$store.state.app.content === "TmObs") {
        return this.customModeSettingZmLvl(itmkndCd);
      } else {
        return this.setCustomZmLvl(itmkndCd);
      }
    },
    /**
     * 個別設定の観測所アイコン表示切替トグル
     */
    setCustomToggle(itmkndCd) {
      // 水位観測所
      if (itmkndCd === 4) {
        return WebStorage.getCustomInfo().stage;
      }
      // 雨量観測所
      else if (
        itmkndCd === 1 ||
        itmkndCd === 2 ||
        itmkndCd === 20 ||
        itmkndCd === 21
      ) {
        return WebStorage.getCustomInfo().rain;
      }
      // 水質観測所
      else if (itmkndCd === 6) {
        return WebStorage.getCustomInfo().wtrQual;
      }
      // ダム諸量観測所
      else if (itmkndCd === 7) {
        return WebStorage.getCustomInfo().dam;
      }
      // 海岸観測所
      else if (itmkndCd === 12) {
        return WebStorage.getCustomInfo().coast;
      }
      // 積雪深観測所
      else if (itmkndCd === 3) {
        return WebStorage.getCustomInfo().snow;
      }
      // 危機管理型水位観測所
      else if (itmkndCd === 300) {
        return WebStorage.getCustomInfo().swin;
      }
      // カメラ
      else if (itmkndCd === 100) {
        return WebStorage.getCustomInfo().cctv;
      }
      // 簡易カメラ
      else if (itmkndCd === 200) {
        return WebStorage.getCustomInfo().scam;
      }
    },
    /**
     * 個別設定の表示開始ズームレベル設定
     */
    setCustomZmLvl(itmkndCd) {
      // 水位観測所
      if (itmkndCd === 4) {
        return WebStorage.getCustomInfo().stageZmLvl;
      }
      // 雨量観測所
      else if (
        itmkndCd === 1 ||
        itmkndCd === 2 ||
        itmkndCd === 20 ||
        itmkndCd === 21
      ) {
        return WebStorage.getCustomInfo().rainZmLvl;
      }
      // 水質観測所
      else if (itmkndCd === 6) {
        return WebStorage.getCustomInfo().wtrQualZmLvl;
      }
      // ダム諸量観測所
      else if (itmkndCd === 7) {
        return WebStorage.getCustomInfo().damZmLvl;
      }
      // 海岸観測所
      else if (itmkndCd === 12) {
        return WebStorage.getCustomInfo().coastZmLvl;
      }
      // 積雪深観測所
      else if (itmkndCd === 3) {
        return WebStorage.getCustomInfo().snowZmLvl;
      }
      // 危機管理型水位観測所
      else if (itmkndCd === 300) {
        return WebStorage.getCustomInfo().swinZmLvl;
      }
      // カメラ
      else if (itmkndCd === 100) {
        return WebStorage.getCustomInfo().cctvZmLvl;
      }
      // 簡易カメラ
      else if (itmkndCd === 200) {
        return WebStorage.getCustomInfo().scamZmLvl;
      }
    },
    /**
     * デフォルト設定の表示開始ズームレベル設定
     */
    setDefaultZmLvl(itmkndCd) {
      // 水位観測所
      if (itmkndCd === 4) {
        return this.$store.state.app.config.mapConfig.zoomTmStg;
      }
      // 雨量観測所
      else if (
        itmkndCd === 1 ||
        itmkndCd === 2 ||
        itmkndCd === 20 ||
        itmkndCd === 21
      ) {
        return this.$store.state.app.config.mapConfig.zoomTmRn;
      }
      // 水質観測所
      else if (itmkndCd === 6) {
        return this.$store.state.app.config.mapConfig.zoomTmQwtr;
      }
      // ダム諸量観測所
      else if (itmkndCd === 7) {
        return this.$store.state.app.config.mapConfig.zoomTmDam;
      }
      // 海岸観測所
      else if (itmkndCd === 12) {
        return this.$store.state.app.config.mapConfig.zoomTmCoast;
      }
      // 積雪深観測所
      else if (itmkndCd === 3) {
        return this.$store.state.app.config.mapConfig.zoomTmSnw;
      }
      // 危機管理型水位観測所
      else if (itmkndCd === 300) {
        return this.$store.state.app.config.mapConfig.zoomTmSwstg;
      }
      // カメラ
      else if (itmkndCd === 100) {
        return this.$store.state.app.config.mapConfig.zoomTmCctv;
      }
      // 簡易カメラ
      else if (itmkndCd === 200) {
        return this.$store.state.app.config.mapConfig.zoomTmScam;
      }
    },
    /**
     * 個別設定モード判定
     */
    isCustomMode() {
      return this.$store.state.map.viewGroup == 5;
    },
    /**
     * 個別設定モードで観測所を個別選択した場合に観測所アイコンが表示されないパターンへの対応
     */
    customModeSettingZmLvl(itmkndCd) {
      //トグルが非表示の場合デフォルトのズームレベルを返す
      if(this.setCustomToggle(itmkndCd) === false) {
        return this.setDefaultZmLvl(itmkndCd);
      }
      // 選択されている観測所種別を取得
      let strSelectedItmkndCd = this.$route.query["itmkndCd"]
      // 数値に変換
      let selectedItmkndCd = Number(strSelectedItmkndCd)
      // 個別設定のズームレベルが条件通りならデフォルトのズームレベルを返す
      if (selectedItmkndCd === itmkndCd &&  this.setCustomZmLvl(itmkndCd) > this.setDefaultZmLvl(itmkndCd)) {
        return this.setDefaultZmLvl(itmkndCd);
      } else {
        return this.setCustomZmLvl(itmkndCd);
      }
    },
  },
  watch: {
    /** 表示市町村取得時刻を監視 */
    townsUpdate() {
      this.getTelemeterGeoJson();
    },
    /** ズームレベルを監視 */
    zoom() {
      clearTimeout(this.requestWaitTimerId);
      // 対象GeoJsonの切替境界で、市町村リストに更新が無い場合を考慮
      if (
        this.zoom == this.mapConfig.zoomTmStg ||
        this.zoom == this.mapConfig.zoomTmStgOv ||
        this.zoom == this.mapConfig.zoomTmDam ||
        this.zoom == this.mapConfig.zoomTmDamOv ||
        this.zoom == this.mapConfig.zoomTmCctv ||
        this.zoom == this.mapConfig.zoomTmRn ||
        this.zoom == this.mapConfig.zoomTmQwtr ||
        this.zoom == this.mapConfig.zoomTmCoast ||
        this.zoom == this.mapConfig.zoomTmSnw ||
        this.zoom == this.mapConfig.zoomTmSwstg ||
        this.zoom == this.mapConfig.zoomTmSwstgOv
      ) {
        this.requestWaitTimerId = setTimeout(
          function () {
            this.getTelemeterGeoJson();
          }.bind(this),
          this.$store.state.map.mapConfig.updateWaitTime
        );
      }
      // 予警報詳細画面を開いている場合のみ取得処理を行う
      if (this.$store.state.app.content == "Riverwarn") {
        this.getBaseobsGeoJson();
      }
    },
    /** 観測日時を監視 */
    baseTime() {
      // 履歴動画未再生状態の場合のみ取得処理を行う
      if (this.$store.getters["radar/isNone"]) {
        this.getTelemeterGeoJson();
      }
      // 予警報詳細画面を開いている場合のみ取得処理を行う
      if (this.$store.state.app.content == "Riverwarn") {
        this.getBaseobsGeoJson();
      }
    },
    /** 地図の表示時間間隔を監視 */
    radarInterval() {
      this.getTelemeterGeoJson();
    },
    /** レーダ履歴動画再生状態 */
    radarHistoryPlayStatus() {
      // 「地図準備状態」の場合のみGeoJson取得を行う
      if (this.$store.getters["radar/isReadyMap"]) {
        if (
          !this.showKnd.stg &&
          !this.showKnd.dam &&
          !this.showKnd.cctv &&
          !this.showKnd.scam &&
          !this.showKnd.rn &&
          !this.showKnd.qwtr &&
          !this.showKnd.coast &&
          !this.showKnd.snw &&
          !this.showKnd.swstg
        ) {
          // 全ての観測所種別が非表示の場合、GeoJSON取得しないため履歴動画再生状態を「再生可状態」に更新
          this.$store.commit("Telemeter/setHistoryPlayPrepStatus", "playable");
        } else {
          // 履歴動画再生状態を「準備状態」にし、各観測所種別毎のGeoJSON取得状態をクリア
          this.$store.commit("Telemeter/setHistoryPlayPrepStatus", "ready");
          this.$store.commit("Telemeter/clearGeoJsonGetStatus");
          // GeoJSON取得
          this.getTelemeterGeoJson();
        }
      }
    },
    /** GeoJSON取得状態更新時刻 */
    geoJsonGetStatusTime() {
      const status = this.$store.state.Telemeter.geoJsonGetStatus;
      // 表示対象の観測所種別のGeoJSON取得状態が全て完了の場合に、再生可能状態に更新する。
      if (
        this.showKnd.stg == status.stg &&
        this.showKnd.dam == status.dam &&
        (((this.showKnd.scam || this.showKnd.cctv) && status.scam) ||
          (!this.showKnd.scam && !this.showKnd.cctv && !status.scam)) &&
        this.showKnd.rn == status.rn &&
        this.showKnd.qwtr == status.qwtr &&
        this.showKnd.coast == status.coast &&
        this.showKnd.snw == status.snw &&
        this.showKnd.swstg == status.swstg
      ) {
        this.$store.commit("Telemeter/setHistoryPlayPrepStatus", "playable");
      }
    },
    /** 表示対象観測所種別 */
    showKnd() {
      this.getTelemeterGeoJson();
    },
    /** 選択中河川予警報マスタ */
    selectedRwDetailMt() {
      this.getBaseobsGeoJson();
    }
  },
};
</script>
